// GENERATED by _gen_public_paths.mjs. Do not edit by hand.
// The data half of the public-routability gate (src/utils/publicRoutability.js):
// which listing and showcase paths the public site will actually serve.
// Regenerate with: node _gen_public_paths.mjs
export const listingPaths = [
  "/australia/melbourne/photographers/yervant-international",
  "/australia/sydney/hair-makeup/lorella-giannini",
  "/austria/carinthia/photographers/stefano-lunardi-photography",
  "/austria/tyrol/wedding-venues/grand-tirolia-kitzbuehel",
  "/austria/tyrol/wedding-venues/ski-hotel-maiensee",
  "/bahamas/exuma/wedding-venues/over-yonder-cay",
  "/belgium/west-flanders/florists/tomas-de-bruyne",
  "/belize/stann-creek/wedding-venues/chabil-mar",
  "/british-virgin-islands/tortola/wedding-venues/long-bay-beach-resort",
  "/cambodia/preah-sihanouk/wedding-venues/six-senses-krabey-island",
  "/caribbean/jamaica/florists/tai-flora-luxe",
  "/costa-rica/guanacaste/wedding-venues/reserva-conchal",
  "/costa-rica/manuel-antonio/wedding-venues/villa-punto-de-vista",
  "/croatia/dubrovnik/photographers/reflexion-studio",
  "/croatia/dubrovnik/wedding-venues/lafodia",
  "/cyprus/larnaca-ayia-napa/wedding-venues/galu-seaside",
  "/cyprus/paphos/wedding-venues/wedding-cyprus-villas",
  "/czech-republic/central-bohemia/wedding-venues/chateau-mcely",
  "/czech-republic/prague/photographers/petr-pelucha-photography",
  "/czech-republic/prague/wedding-venues/the-augustine-prague",
  "/denmark/copenhagen/jewellers/sif-jakobs-jewellery",
  "/england/berkshire/wedding-venues/benham-park",
  "/england/berkshire/wedding-venues/cliveden-house",
  "/england/berkshire/wedding-venues/coworth-park",
  "/england/berkshire/wedding-venues/lillibrooke-manor",
  "/england/berkshire/wedding-venues/the-post-barn",
  "/england/berkshire/wedding-venues/wickham-house",
  "/england/buckinghamshire/florists/sorcha-herbert",
  "/england/buckinghamshire/wedding-venues/hedsor-house",
  "/england/buckinghamshire/wedding-venues/waddesdon-manor",
  "/england/cheshire/wedding-venues/nunsmere-hall-hotel",
  "/england/cheshire/wedding-venues/peckforton-castle",
  "/england/cornwall/wedding-venues/fowey-hall",
  "/england/cornwall/wedding-venues/hotel-tresanton",
  "/england/cornwall/wedding-venues/pentillie-castle",
  "/england/county-durham/wedding-venues/auckland-castle",
  "/england/cumbria/wedding-venues/askham-hall",
  "/england/cumbria/wedding-venues/broadoaks-country-house",
  "/england/cumbria/wedding-venues/casterton-grange",
  "/england/derbyshire/wedding-venues/tissington-hall",
  "/england/derbyshire/wedding-venues/upper-house-hayfield",
  "/england/devon/wedding-venues/bickleigh-castle",
  "/england/devon/wedding-venues/bovey-castle",
  "/england/devon/wedding-venues/horn-of-plenty",
  "/england/dorset/videographers/gorgeous-films",
  "/england/dorset/wedding-venues/captains-club-hotel",
  "/england/east-sussex/wedding-venues/the-george-in-rye",
  "/england/essex/hair-makeup/botias-hair-and-makeup",
  "/england/essex/wedding-venues/creeksea-place",
  "/england/essex/wedding-venues/hylands-estate",
  "/england/essex/wedding-venues/leez-priory",
  "/england/essex/wedding-venues/that-amazing-place",
  "/england/essex/wedding-venues/valentines-mansion",
  "/england/gloucestershire/wedding-venues/briery-hill-house",
  "/england/gloucestershire/wedding-venues/clearwell-castle",
  "/england/gloucestershire/wedding-venues/elmore-court",
  "/england/gloucestershire/wedding-venues/tan-house-newland",
  "/england/gloucestershire/wedding-venues/thornbury-castle",
  "/england/gloucestershire/wedding-venues/wyck-hill-house",
  "/england/hampshire/bridal-boutiques/beatrice-espinosa-bridal",
  "/england/hampshire/hair-makeup/wedding-hair-and-makeup-by-lisa",
  "/england/hampshire/wedding-venues/chewton-glen",
  "/england/hampshire/wedding-venues/montagu-arms-hotel",
  "/england/hampshire/wedding-venues/the-elvetham",
  "/england/hertfordshire/bridal-boutiques/shimmering-ivory",
  "/england/hertfordshire/florists/amie-bone-flowers",
  "/england/hertfordshire/hair-makeup/makeup-by-mirna",
  "/england/hertfordshire/photographers/lina-and-tom-photography",
  "/england/hertfordshire/photographers/lovexposed-photography",
  "/england/hertfordshire/photographers/the-studio-without-walls",
  "/england/hertfordshire/videographers/gaetano-di-giacomo-media-production",
  "/england/hertfordshire/wedding-venues/micklefield-hall",
  "/england/kent/wedding-venues/hever-castle",
  "/england/kent/wedding-venues/leeds-castle",
  "/england/lancashire/entertainment/six15-events",
  "/england/lincolnshire/wedding-venues/harlaxton-manor",
  "/england/lincolnshire/wedding-venues/stubton-hall",
  "/england/london/bridal-boutiques/caroline-castigliano",
  "/england/london/bridal-boutiques/temperley-london",
  "/england/london/entertainment/aston-band",
  "/england/london/entertainment/down-for-the-count",
  "/england/london/entertainment/girls-international",
  "/england/london/entertainment/rocks-the-room",
  "/england/london/entertainment/the-function-band",
  "/england/london/florists/chantal-flores-design",
  "/england/london/florists/elizabeth-marsh-floral-design",
  "/england/london/florists/farima-perry",
  "/england/london/florists/flower-station",
  "/england/london/florists/in-water-flowers",
  "/england/london/florists/jamie-aston",
  "/england/london/florists/mcqueens-flowers",
  "/england/london/florists/rebecca-mays",
  "/england/london/florists/shilpa-reddy",
  "/england/london/florists/sweet-pea-floral-design",
  "/england/london/florists/wildabout",
  "/england/london/florists/zita-elze",
  "/england/london/hair-makeup/elizabeth-hsieh",
  "/england/london/hair-makeup/khushi-the-makeup-artist",
  "/england/london/photographers/emma-jane-photography",
  "/england/london/photographers/paola-de-paola-photography",
  "/england/london/photographers/stuart-wood-photography",
  "/england/london/videographers/andrei-weddings",
  "/england/london/videographers/denee-motion",
  "/england/london/videographers/hd-moments",
  "/england/london/wedding-planners/angela-salzano",
  "/england/london/wedding-venues/116-pall-mall",
  "/england/london/wedding-venues/claridges",
  "/england/london/wedding-venues/eltham-palace",
  "/england/london/wedding-venues/fulham-palace",
  "/england/london/wedding-venues/haymarket-hotel",
  "/england/london/wedding-venues/hurlingham-club",
  "/england/london/wedding-venues/mandarin-oriental-hyde-park",
  "/england/london/wedding-venues/one-marylebone",
  "/england/london/wedding-venues/shangri-la-the-shard",
  "/england/london/wedding-venues/spencer-house",
  "/england/london/wedding-venues/strawberry-hill-house",
  "/england/london/wedding-venues/syon-park",
  "/england/london/wedding-venues/the-berkeley",
  "/england/london/wedding-venues/the-dorchester",
  "/england/london/wedding-venues/the-goring",
  "/england/london/wedding-venues/the-greenhouses",
  "/england/london/wedding-venues/the-london-edition",
  "/england/london/wedding-venues/the-ritz-london",
  "/england/london/wedding-venues/the-savoy",
  "/england/london/wedding-venues/the-wallace-collection",
  "/england/london/wedding-venues/tudor-barn-eltham",
  "/england/norfolk/wedding-venues/worstead-estate",
  "/england/north-yorkshire/wedding-venues/allerton-castle",
  "/england/north-yorkshire/wedding-venues/birdsall-house",
  "/england/north-yorkshire/wedding-venues/grantley-hall",
  "/england/north-yorkshire/wedding-venues/swinton-park",
  "/england/northamptonshire/wedding-venues/crockwell-farm",
  "/england/northamptonshire/wedding-venues/rushton-hall-hotel-spa",
  "/england/oxfordshire/florists/foxgloves-and-roses",
  "/england/oxfordshire/wedding-venues/bay-tree-hotel-burford",
  "/england/oxfordshire/wedding-venues/blenheim-palace",
  "/england/oxfordshire/wedding-venues/caswell-house",
  "/england/shropshire/photographers/victoria-amrose-photography",
  "/england/shropshire/wedding-venues/iscoyd-park",
  "/england/somerset/wedding-venues/brympton-house",
  "/england/somerset/wedding-venues/haselbury-mill",
  "/england/somerset/wedding-venues/orchardleigh-house-uk",
  "/england/suffolk/wedding-venues/hengrave-hall",
  "/england/suffolk/wedding-venues/retreat-east",
  "/england/surrey/hair-makeup/nadine-pyke",
  "/england/surrey/videographers/vic-rivero-films",
  "/england/surrey/wedding-venues/bury-court",
  "/england/surrey/wedding-venues/de-vere-horsley-estate",
  "/england/surrey/wedding-venues/farnham-castle",
  "/england/surrey/wedding-venues/hampton-court-palace",
  "/england/surrey/wedding-venues/kew-palace",
  "/england/surrey/wedding-venues/lythe-hill",
  "/england/surrey/wedding-venues/nutfield-priory",
  "/england/west-midlands/wedding-venues/hampton-manor",
  "/england/west-sussex/hair-makeup/becky-flynn",
  "/england/west-sussex/wedding-venues/amberley-castle",
  "/england/west-sussex/wedding-venues/farbridge",
  "/france/arcachon-bay/wedding-venues/villa-la-tosca",
  "/france/bordeaux-and-aquitaine/wedding-venues/domaine-des-etangs",
  "/france/french-riviera/wedding-venues/chateau-saint-georges",
  "/france/ile-de-france/videographers/znaharchuk-studio",
  "/france/languedoc/florists/fleurs-design-by-faustine",
  "/france/loire-valley/wedding-venues/chateau-de-cheronne",
  "/france/paris/wedding-venues/chateau-de-ferrieres",
  "/france/provence/videographers/gordon-wedding-films",
  "/gibraltar/wedding-venues/mons-calpe-suite",
  "/greece/athens/wedding-planners/naido-wedding",
  "/greece/attica/photographers/photomad",
  "/greece/attica/videographers/cinema-of-poetry",
  "/greece/corfu/photographers/studio27-by-andreas-politis",
  "/greece/corfu/wedding-venues/the-courti-estate",
  "/greece/corfu/wedding-venues/villa-sylva",
  "/greece/crete/photographers/andreas-markakis-photography",
  "/greece/cyclades/wedding-venues/saint-john-mykonos",
  "/greece/santorini/wedding-planners/stella-and-moscha",
  "/greece/santorini/wedding-venues/la-maltese",
  "/hungary/budapest/wedding-venues/kimpton-bem-budapest",
  "/indonesia/bali/wedding-venues/alila-manggis",
  "/indonesia/bali/wedding-venues/alila-ubud",
  "/indonesia/bali/wedding-venues/the-kayon-ubud-resort",
  "/indonesia/bali/wedding-venues/the-kayon-valley-resort-ubud",
  "/ireland/county-limerick/wedding-venues/adare-manor",
  "/ireland/donegal/wedding-venues/lough-eske-castle",
  "/italy/amalfi-coast/hair-makeup/anna-rosa-makeup-italy",
  "/italy/amalfi-coast/photographers/andrea-gallucci-photography",
  "/italy/amalfi-coast/photographers/detito-photography",
  "/italy/amalfi-coast/photographers/infinity-studio-italy",
  "/italy/amalfi-coast/photographers/pierpaolo-perri",
  "/italy/amalfi-coast/wedding-planners/bella-sposa",
  "/italy/amalfi-coast/wedding-planners/italian-event-planners",
  "/italy/amalfi-coast/wedding-planners/la-calla-events",
  "/italy/amalfi-coast/wedding-planners/mr-and-mrs-wedding-in-italy",
  "/italy/amalfi-coast/wedding-planners/ramona-avitabile-wedding-planner",
  "/italy/amalfi-coast/wedding-planners/say-yes-in-italy",
  "/italy/amalfi-coast/wedding-planners/sposa-mediterranea",
  "/italy/amalfi-coast/wedding-planners/the-knot-in-italy",
  "/italy/amalfi-coast/wedding-planners/weddings-amalfi",
  "/italy/amalfi-coast/wedding-venues/ma-ca-casa-privata",
  "/italy/amalfi-coast/wedding-venues/palazzo-suriano-heritage-hotel",
  "/italy/basilicata/wedding-venues/grand-hotel-pianeta-maratea-resort",
  "/italy/calabria/photographers/rocco-daniele-photography",
  "/italy/calabria/wedding-venues/villa-paola-tropea",
  "/italy/campania/bridal-boutiques/ferdinand-atelier",
  "/italy/campania/wedding-planners/dario-varsalona",
  "/italy/campania/wedding-planners/ester-chianelli-weddings-events",
  "/italy/campania/wedding-planners/iole-criscitiello",
  "/italy/campania/wedding-planners/med-instyle",
  "/italy/campania/wedding-planners/meissa-eventi",
  "/italy/campania/wedding-planners/o-sarracino-events",
  "/italy/campania/wedding-planners/sara-dangelo",
  "/italy/campania/wedding-planners/sophisticated-weddings",
  "/italy/campania/wedding-planners/wem-eventi",
  "/italy/campania/wedding-venues/esplanade-boutique-hotel-paestum",
  "/italy/campania/wedding-venues/hotel-alpha",
  "/italy/campania/wedding-venues/palazzo-ducale-di-avella-e-anfiteatro-romano",
  "/italy/campania/wedding-venues/savoy-hotel-spa-paestum",
  "/italy/campania/wedding-venues/the-britannique",
  "/italy/campania/wedding-venues/villa-balke",
  "/italy/campania/wedding-venues/villa-del-vecchio-pozzo-in-posillipo",
  "/italy/campania/wedding-venues/villa-la-rondinaia",
  "/italy/capri/wedding-venues/jk-place-capri",
  "/italy/emilia-romagna/wedding-planners/italian-dream-weddings",
  "/italy/emilia-romagna/wedding-planners/joy-wedding-federica-tamborini",
  "/italy/emilia-romagna/wedding-planners/paolo-cicognani",
  "/italy/friuli-venezia-giulia/wedding-venues/villa-gallici-deciani",
  "/italy/lake-como/florists/lada-fiori",
  "/italy/lake-como/hair-makeup/samantha-pretto",
  "/italy/lake-como/photographers/lichtag-photography",
  "/italy/lake-como/photographers/matteo-cuzzola-photography",
  "/italy/lake-como/wedding-planners/elisa-prati-wedding-italy",
  "/italy/lake-como/wedding-planners/my-lake-como-wedding",
  "/italy/lake-como/wedding-venues/villa-nascosta",
  "/italy/lake-maggiore/wedding-planners/lake-maggiore-wedding-style",
  "/italy/lazio/wedding-venues/la-posta-vecchia-hotel",
  "/italy/lazio/wedding-venues/valle-dellaquila",
  "/italy/liguria/photographers/giandomenico-cosentino-photography",
  "/italy/lombardy/wedding-planners/garini-immagina-eventi",
  "/italy/lombardy/wedding-planners/natasha-barbato",
  "/italy/lombardy/wedding-planners/wa-lab-events",
  "/italy/lombardy/wedding-planners/white-emotion",
  "/italy/lombardy/wedding-venues/villa-sofia",
  "/italy/marche/wedding-venues/villa-nena",
  "/italy/milan/florists/elisabetta-cardani",
  "/italy/piedmont/videographers/nozze-da-film",
  "/italy/piedmont/wedding-planners/italian-wedding-company",
  "/italy/piedmont/wedding-planners/leo-eventi",
  "/italy/piedmont/wedding-planners/un-giorno-un-sogno",
  "/italy/piedmont/wedding-venues/castello-di-collegno",
  "/italy/puglia/photographers/giuseppe-suma-weddings",
  "/italy/puglia/photographers/pino-coduti-photography",
  "/italy/puglia/wedding-planners/marita-campanella",
  "/italy/puglia/wedding-venues/gattarella-puglia-resort",
  "/italy/puglia/wedding-venues/masseria-don-luigi",
  "/italy/puglia/wedding-venues/tenuta-pinto",
  "/italy/puglia/wedding-venues/torre-del-parco",
  "/italy/rome/entertainment/mr-music-italy",
  "/italy/rome/florists/fiori-amore-e-fantasia",
  "/italy/rome/florists/flavia-bruni",
  "/italy/rome/florists/floreventi",
  "/italy/rome/florists/maria-luisa-rocchi-flowers",
  "/italy/rome/photographers/giuliano-bausano",
  "/italy/rome/photographers/ortica-wedding",
  "/italy/rome/photographers/silvia-cleri-photography",
  "/italy/rome/wedding-planners/anita-galafate",
  "/italy/rome/wedding-planners/anna-chiatto",
  "/italy/rome/wedding-planners/denise-more",
  "/italy/rome/wedding-planners/dream-weddings-by-francesca-resciniti",
  "/italy/rome/wedding-planners/eventilab-weddings",
  "/italy/rome/wedding-planners/ilmiomatrimonio-mywedinitaly",
  "/italy/rome/wedding-planners/le-reve",
  "/italy/rome/wedding-planners/mgda-events",
  "/italy/rome/wedding-planners/parade-wedding-event-planner",
  "/italy/rome/wedding-planners/patrizia-cilli-events",
  "/italy/rome/wedding-planners/roberta-torresan",
  "/italy/rome/wedding-planners/sanda-pandza-events",
  "/italy/rome/wedding-venues/boscolo-exedra-roma",
  "/italy/rome/wedding-venues/donna-camilla-savelli-hotel",
  "/italy/rome/wedding-venues/the-st-regis-rome",
  "/italy/rome/wedding-venues/the-westin-excelsior-rome",
  "/italy/sardinia/wedding-venues/the-hotel-cala-di-volpe-a-luxury-collection-hotel",
  "/italy/sicily/photographers/ds-studiofotografico",
  "/italy/sicily/photographers/marco-ficili",
  "/italy/sicily/photographers/nino-lombardo-photography",
  "/italy/sicily/wedding-planners/loviu-events",
  "/italy/sicily/wedding-planners/marica-events",
  "/italy/sicily/wedding-planners/my-sicilian-wedding",
  "/italy/sicily/wedding-planners/my-sicily-wedding",
  "/italy/sicily/wedding-planners/pangiunia-wedding",
  "/italy/sicily/wedding-planners/paola-lapi-luxury-event",
  "/italy/sicily/wedding-planners/sicilian-wedding-day",
  "/italy/sicily/wedding-planners/sparx-wedding",
  "/italy/sicily/wedding-planners/taormina-weddings",
  "/italy/sicily/wedding-venues/ballium-luxury-relais",
  "/italy/sicily/wedding-venues/la-plage",
  "/italy/sicily/wedding-venues/susafa",
  "/italy/trentino-alto-adige/wedding-venues/hotel-castle-fragsburg",
  "/italy/tuscany/florists/bottega-dei-fiori",
  "/italy/tuscany/florists/francis-flowers",
  "/italy/tuscany/photographers/daniele-vertelli-photography",
  "/italy/tuscany/photographers/diego-giusti-photographer",
  "/italy/tuscany/photographers/light-and-dreams",
  "/italy/tuscany/photographers/michele-monasta-photography",
  "/italy/tuscany/photographers/simone-perini-photography",
  "/italy/tuscany/photographers/studio-fotografico-bacci",
  "/italy/tuscany/wedding-planners/bianco-bouquet-weddings-events",
  "/italy/tuscany/wedding-planners/glam-events-in-tuscany",
  "/italy/tuscany/wedding-planners/il-giorno-perfetto-glenda-marradi",
  "/italy/tuscany/wedding-planners/infinity-weddings",
  "/italy/tuscany/wedding-planners/italian-eye",
  "/italy/tuscany/wedding-planners/la-bottega-del-sogno",
  "/italy/tuscany/wedding-planners/magnolia-wedding-planner",
  "/italy/tuscany/wedding-planners/roras-destination-wedding",
  "/italy/tuscany/wedding-planners/tuscan-dmc",
  "/italy/tuscany/wedding-planners/your-secret-tuscany",
  "/italy/tuscany/wedding-venues/agriturismo-cima-alla-serra",
  "/italy/tuscany/wedding-venues/baglioni-cala-del-porto",
  "/italy/tuscany/wedding-venues/borgo-bucciano",
  "/italy/tuscany/wedding-venues/borgo-di-recenza",
  "/italy/tuscany/wedding-venues/burlamacchi-villas",
  "/italy/tuscany/wedding-venues/casale-de-pasquinelli",
  "/italy/tuscany/wedding-venues/castel-monastero-resort",
  "/italy/tuscany/wedding-venues/castello-di-velona",
  "/italy/tuscany/wedding-venues/collegio-alla-querce",
  "/italy/tuscany/wedding-venues/collemassari",
  "/italy/tuscany/wedding-venues/grotta-giusti-thermal-spa-resort",
  "/italy/tuscany/wedding-venues/gve-weddings-villas",
  "/italy/tuscany/wedding-venues/hotel-castello-di-casole-a-timbers-resort",
  "/italy/tuscany/wedding-venues/hotel-le-fontanelle",
  "/italy/tuscany/wedding-venues/hotel-villa-il-patriarca",
  "/italy/tuscany/wedding-venues/il-falconiere",
  "/italy/tuscany/wedding-venues/il-salviatino-florence",
  "/italy/tuscany/wedding-venues/la-corte-dei-papi-relais-spa-restaurant",
  "/italy/tuscany/wedding-venues/landana",
  "/italy/tuscany/wedding-venues/palazzetto-rosso",
  "/italy/tuscany/wedding-venues/paradis-pietrasanta",
  "/italy/tuscany/wedding-venues/podere-castellare",
  "/italy/tuscany/wedding-venues/pometti-estate-villa-boscarello",
  "/italy/tuscany/wedding-venues/relais-la-costa-tuscany",
  "/italy/tuscany/wedding-venues/relais-santa-croce",
  "/italy/tuscany/wedding-venues/the-st-regis-florence",
  "/italy/tuscany/wedding-venues/villa-agape",
  "/italy/tuscany/wedding-venues/villa-castiglione",
  "/italy/tuscany/wedding-venues/villa-darte-wedding",
  "/italy/tuscany/wedding-venues/villa-di-catignano",
  "/italy/tuscany/wedding-venues/villa-il-cerretino",
  "/italy/tuscany/wedding-venues/villa-mangiacane",
  "/italy/tuscany/wedding-venues/villa-michaela-tuscany",
  "/italy/umbria/photographers/alessandro-mari-photography",
  "/italy/umbria/photographers/andrea-federica",
  "/italy/umbria/photographers/rellini-art-studio",
  "/italy/umbria/wedding-planners/dream-on-wedding-team",
  "/italy/umbria/wedding-planners/umbria-weddings-and-events",
  "/italy/umbria/wedding-venues/abbazia-san-faustino",
  "/italy/umbria/wedding-venues/borgo-antichi-orti-assisi",
  "/italy/umbria/wedding-venues/castello-di-montignano",
  "/italy/umbria/wedding-venues/castello-di-petrata",
  "/italy/umbria/wedding-venues/castello-di-solfagnano",
  "/italy/umbria/wedding-venues/le-torri-di-bagnara-castles",
  "/italy/umbria/wedding-venues/park-hotel-ai-cappuccini",
  "/italy/umbria/wedding-venues/san-pietro-wedding",
  "/italy/umbria/wedding-venues/tenuta-san-masseo",
  "/italy/umbria/wedding-venues/torre-collevento",
  "/italy/veneto/wedding-planners/angel-lion-weddings",
  "/italy/veneto/wedding-planners/mirko-zago-sparkling-weddings",
  "/italy/veneto/wedding-planners/more-than-weddings",
  "/italy/veneto/wedding-planners/noemi-wedding",
  "/italy/veneto/wedding-planners/suellen-fernandes-weddings",
  "/italy/veneto/wedding-venues/ca-sagredo",
  "/italy/veneto/wedding-venues/castello-bevilacqua",
  "/italy/veneto/wedding-venues/jw-marriott-venice",
  "/italy/veneto/wedding-venues/the-gritti-palace",
  "/italy/veneto/wedding-venues/villa-cariola",
  "/italy/veneto/wedding-venues/villa-pace",
  "/italy/venice/hair-makeup/lisa-semenzato",
  "/italy/venice/photographers/alfonso-lorenzetto",
  "/italy/venice/photographers/barbara-zanon-photography",
  "/italy/venice/photographers/mauro-pozzer-photography",
  "/italy/venice/videographers/whitesfilm-wedding-videography",
  "/jamaica/st-james/wedding-venues/sandals-royal-caribbean",
  "/malaysia/pahang/wedding-venues/the-chateau-spa",
  "/malaysia/terengganu/wedding-venues/the-taaras-beach-spa-resort",
  "/maldives/laamu-atoll/wedding-venues/six-senses-laamu",
  "/maldives/north-male-atoll/wedding-venues/ritz-carlton-maldives-fari-islands",
  "/maldives/south-male-atoll/wedding-venues/waldorf-astoria-maldives",
  "/mexico/riviera-nayarit/wedding-venues/siari-riviera-nayarit",
  "/mexico/riviera-nayarit/wedding-venues/st-regis-punta-mita",
  "/montenegro/budva-riviera/wedding-venues/villa-ponta-melagrana",
  "/montenegro/lustica-bay/wedding-venues/the-chedi-lustica-bay",
  "/morocco/draa-valley/wedding-venues/kasbah-des-caids",
  "/morocco/marrakech-safi/wedding-venues/four-seasons-marrakech",
  "/morocco/marrakech-safi/wedding-venues/la-mamounia",
  "/morocco/marrakech-safi/wedding-venues/palais-ronsard",
  "/morocco/marrakech-safi/wedding-venues/royal-mansour-marrakech",
  "/northern-ireland/county-down/wedding-venues/hillsborough-castle",
  "/poland/west-pomerania/wedding-venues/manowce-palace",
  "/portugal/alentejo/wedding-venues/craveiral-farmhouse",
  "/portugal/centro/wedding-venues/luz-houses",
  "/portugal/lisbon/photographers/dimas-frolov-photography",
  "/qatar/doha/wedding-venues/mandarin-oriental-doha",
  "/qatar/doha/wedding-venues/raffles-doha",
  "/qatar/doha/wedding-venues/rosewood-doha",
  "/romania/bucharest-and-ilfov/wedding-venues/iris-orangerie",
  "/saudi-arabia/tabuk/wedding-venues/six-senses-southern-dunes",
  "/scotland/aberdeenshire/wedding-venues/cluny-castle",
  "/scotland/aberdeenshire/wedding-venues/cortes-house",
  "/scotland/east-lothian/wedding-venues/greywalls-hotel-chez-roux",
  "/scotland/edinburgh/wedding-venues/dundas-castle",
  "/scotland/fife/wedding-venues/old-course-hotel",
  "/scotland/highlands/wedding-venues/inverlochy-castle-hotel",
  "/scotland/midlothian/wedding-venues/borthwick-castle",
  "/slovenia/gorenjska/wedding-venues/bled-rose-hotel",
  "/slovenia/gorenjska/wedding-venues/strmol-castle",
  "/slovenia/gorenjska/wedding-venues/vila-bled",
  "/south-africa/cape-town/wedding-venues/tintswalo-atlantic",
  "/south-africa/hermanus/wedding-venues/bona-dea",
  "/spain/balearic-islands/wedding-planners/the-mallorca-wedding-company",
  "/spain/catalonia/wedding-venues/can-riera-de-la-pineda",
  "/spain/catalonia/wedding-venues/casa-nova-estate",
  "/spain/catalonia/wedding-venues/finca-la-concertista",
  "/spain/catalonia/wedding-venues/hotel-castell-d-emporda",
  "/spain/catalonia/wedding-venues/mas-huix",
  "/spain/catalonia/wedding-venues/mas-torroella-luxury-villa-spa",
  "/spain/catalonia/wedding-venues/masia-cabellut",
  "/spain/catalonia/wedding-venues/masia-victoria",
  "/spain/catalonia/wedding-venues/villa-catalina",
  "/spain/galicia/photographers/volvoreta-photography",
  "/spain/ibiza/photographers/kaleidos-wedding",
  "/spain/ibiza/wedding-venues/can-lluc-hotel",
  "/spain/ibiza/wedding-venues/finca-delica",
  "/spain/ibiza/wedding-venues/kazamor-ibiza",
  "/spain/ibiza/wedding-venues/pura-vida-beach-ibiza",
  "/spain/ibiza/wedding-venues/pure-house-ibiza",
  "/spain/mallorca/wedding-venues/castell-son-claret",
  "/spain/mallorca/wedding-venues/finca-morneta",
  "/spain/mallorca/wedding-venues/jumeirah-port-soller",
  "/spain/marbella/wedding-venues/el-martinete-villa",
  "/spain/menorca/wedding-venues/amagatay-menorca",
  "/spain/tenerife/wedding-venues/the-ritz-carlton-abama",
  "/spain/valencia/wedding-venues/westin-valencia",
  "/sri-lanka/colombo/videographers/lights-and-magic",
  "/st-lucia/castries/wedding-venues/villa-susanna",
  "/st-vincent-and-the-grenadines/grenadines/wedding-venues/the-cotton-house",
  "/switzerland/bernese-oberland/videographers/story-of-your-day",
  "/switzerland/geneva/wedding-venues/hotel-president-wilson",
  "/switzerland/lake-lucerne/wedding-venues/burgenstock-resort",
  "/switzerland/lake-lucerne/wedding-venues/kempinski-palace-engelberg",
  "/switzerland/obwalden/wedding-venues/frutt-mountain-resort",
  "/switzerland/vaud/wedding-planners/daria-events",
  "/tanzania/zanzibar/wedding-venues/ycona",
  "/thailand/koh-samui/wedding-venues/silavadee",
  "/thailand/phuket/florists/iamflower",
  "/thailand/phuket/wedding-venues/naka-island-phuket",
  "/thailand/phuket/wedding-venues/vanderbilt-estate",
  "/turkey/bodrum/wedding-venues/bodrum-edition",
  "/turkey/bodrum/wedding-venues/six-senses-kaplankaya",
  "/turkey/bodrum/wedding-venues/villa-macakizi-bodrum",
  "/turkey/istanbul/wedding-venues/ciragan-palace-kempinski",
  "/turkey/istanbul/wedding-venues/swissotel-bosphorus-istanbul",
  "/turkey/mugla/wedding-venues/xo-cape-arnna",
  "/uae/dubai/wedding-planners/ikigaii-planners",
  "/uae/dubai/wedding-venues/burj-al-arab-jumeirah",
  "/uae/dubai/wedding-venues/jumeirah-zabeel-saray",
  "/uae/dubai/wedding-venues/ritz-carlton-dubai",
  "/united-arab-emirates/dubai/wedding-venues/armani-hotel-dubai",
  "/united-arab-emirates/dubai/wedding-venues/one-only-royal-mirage",
  "/united-states/california/photographers/duke-photography",
  "/united-states/california/photographers/samuel-lippke-studios",
  "/united-states/washington/photographers/emett-joseph-photography",
  "/usa/california/wedding-venues/auberge-du-soleil",
  "/usa/california/wedding-venues/greystone-mansion",
  "/usa/california/wedding-venues/hotel-bel-air",
  "/usa/new-york/wedding-venues/oheka-castle",
  "/usa/rhode-island/wedding-venues/rosecliff",
  "/wales/cardiff/hair-makeup/loxus-hair-and-makeup",
  "/wales/powys/wedding-venues/lake-country-house"
];

export const showcasePaths = [
  "/showcase/116-pall-mall",
  "/showcase/abbazia-san-faustino",
  "/showcase/adare-manor",
  "/showcase/agriturismo-cima-alla-serra",
  "/showcase/al-habtoor-palace-budapest",
  "/showcase/alessandro-mari-photography",
  "/showcase/alfonso-lorenzetto",
  "/showcase/alila-manggis",
  "/showcase/alila-ubud",
  "/showcase/allerton-castle",
  "/showcase/amagatay-menorca",
  "/showcase/amberley-castle",
  "/showcase/amie-bone-flowers",
  "/showcase/andrea-federica",
  "/showcase/andrea-gallucci-photography",
  "/showcase/andreas-markakis-photography",
  "/showcase/andrei-weddings",
  "/showcase/angel-lion-weddings",
  "/showcase/angela-salzano",
  "/showcase/anita-galafate",
  "/showcase/anna-chiatto",
  "/showcase/anna-rosa-makeup-italy",
  "/showcase/armani-hotel-dubai",
  "/showcase/askham-hall",
  "/showcase/aston-band",
  "/showcase/auberge-du-soleil",
  "/showcase/auckland-castle",
  "/showcase/baglioni-cala-del-porto",
  "/showcase/ballium-luxury-relais",
  "/showcase/barbara-zanon-photography",
  "/showcase/bay-tree-hotel-burford",
  "/showcase/beatrice-espinosa-bridal",
  "/showcase/becky-flynn",
  "/showcase/bella-sposa",
  "/showcase/benham-park",
  "/showcase/bianco-bouquet-weddings-events",
  "/showcase/bickleigh-castle",
  "/showcase/birdsall-house",
  "/showcase/bled-rose-hotel",
  "/showcase/blenheim-palace",
  "/showcase/bodrum-edition",
  "/showcase/bona-dea",
  "/showcase/borgo-antichi-orti-assisi",
  "/showcase/borgo-bucciano",
  "/showcase/borgo-di-recenza",
  "/showcase/borthwick-castle",
  "/showcase/boscolo-exedra-roma",
  "/showcase/botias-hair-and-makeup",
  "/showcase/bottega-dei-fiori",
  "/showcase/bovey-castle",
  "/showcase/briery-hill-house",
  "/showcase/broadoaks-country-house",
  "/showcase/brympton-house",
  "/showcase/burgenstock-resort",
  "/showcase/burj-al-arab-jumeirah",
  "/showcase/burlamacchi-villas",
  "/showcase/bury-court",
  "/showcase/ca-sagredo",
  "/showcase/can-lluc-hotel",
  "/showcase/can-riera-de-la-pineda",
  "/showcase/captains-club-hotel",
  "/showcase/caroline-castigliano",
  "/showcase/casa-nova-estate",
  "/showcase/casale-de-pasquinelli",
  "/showcase/castel-monastero-resort",
  "/showcase/castell-son-claret",
  "/showcase/castello-bevilacqua",
  "/showcase/castello-di-collegno",
  "/showcase/castello-di-montignano",
  "/showcase/castello-di-petrata",
  "/showcase/castello-di-solfagnano",
  "/showcase/castello-di-velona",
  "/showcase/casterton-grange",
  "/showcase/caswell-house",
  "/showcase/chabil-mar",
  "/showcase/chantal-flores-design",
  "/showcase/chateau-de-cheronne",
  "/showcase/chateau-de-ferrieres",
  "/showcase/chateau-mcely",
  "/showcase/chateau-saint-georges",
  "/showcase/chewton-glen",
  "/showcase/cinema-of-poetry",
  "/showcase/ciragan-palace-kempinski",
  "/showcase/claridges",
  "/showcase/clearwell-castle",
  "/showcase/cliveden-house",
  "/showcase/cluny-castle",
  "/showcase/collegio-alla-querce",
  "/showcase/collemassari",
  "/showcase/corinthia-london",
  "/showcase/cortes-house",
  "/showcase/coworth-park",
  "/showcase/craveiral-farmhouse",
  "/showcase/creeksea-place",
  "/showcase/crockwell-farm",
  "/showcase/daniele-vertelli-photography",
  "/showcase/daria-events",
  "/showcase/dario-varsalona",
  "/showcase/de-vere-horsley-estate",
  "/showcase/denee-motion",
  "/showcase/denise-more",
  "/showcase/detito-photography",
  "/showcase/diego-giusti-photographer",
  "/showcase/dimas-frolov-photography",
  "/showcase/domaine-des-etangs",
  "/showcase/donna-camilla-savelli-hotel",
  "/showcase/down-for-the-count",
  "/showcase/dream-on-wedding-team",
  "/showcase/dream-weddings-by-francesca-resciniti",
  "/showcase/ds-studiofotografico",
  "/showcase/duke-photography",
  "/showcase/dundas-castle",
  "/showcase/el-martinete-villa",
  "/showcase/elisa-prati-wedding-italy",
  "/showcase/elisabetta-cardani",
  "/showcase/elizabeth-hsieh",
  "/showcase/elizabeth-marsh-floral-design",
  "/showcase/elmore-court",
  "/showcase/eltham-palace",
  "/showcase/emett-joseph-photography",
  "/showcase/emma-jane-photography",
  "/showcase/esplanade-boutique-hotel-paestum",
  "/showcase/ester-chianelli-weddings-events",
  "/showcase/eventilab-weddings",
  "/showcase/farbridge",
  "/showcase/farima-perry",
  "/showcase/farnham-castle",
  "/showcase/ferdinand-atelier",
  "/showcase/finca-delica",
  "/showcase/finca-la-concertista",
  "/showcase/finca-morneta",
  "/showcase/fiori-amore-e-fantasia",
  "/showcase/flavia-bruni",
  "/showcase/fleurs-design-by-faustine",
  "/showcase/floreventi",
  "/showcase/flower-station",
  "/showcase/four-seasons-marrakech",
  "/showcase/fowey-hall",
  "/showcase/foxgloves-and-roses",
  "/showcase/francis-flowers",
  "/showcase/frutt-mountain-resort",
  "/showcase/fulham-palace",
  "/showcase/gaetano-di-giacomo-media-production",
  "/showcase/galu-seaside",
  "/showcase/garini-immagina-eventi",
  "/showcase/gattarella-puglia-resort",
  "/showcase/giandomenico-cosentino-photography",
  "/showcase/girls-international",
  "/showcase/giuliano-bausano",
  "/showcase/giuseppe-suma-weddings",
  "/showcase/glam-events-in-tuscany",
  "/showcase/gordon-wedding-films",
  "/showcase/gorgeous-films",
  "/showcase/grand-hotel-pianeta-maratea-resort",
  "/showcase/grand-tirolia-kitzbuehel",
  "/showcase/grantley-hall",
  "/showcase/greystone-mansion",
  "/showcase/greywalls-hotel-chez-roux",
  "/showcase/grotta-giusti-thermal-spa-resort",
  "/showcase/gve-weddings-villas",
  "/showcase/hampton-court-palace",
  "/showcase/hampton-manor",
  "/showcase/harlaxton-manor",
  "/showcase/haselbury-mill",
  "/showcase/haymarket-hotel",
  "/showcase/hd-moments",
  "/showcase/hedsor-house",
  "/showcase/hengrave-hall",
  "/showcase/hever-castle",
  "/showcase/hillsborough-castle",
  "/showcase/horn-of-plenty",
  "/showcase/hotel-alpha",
  "/showcase/hotel-bel-air",
  "/showcase/hotel-castell-d-emporda",
  "/showcase/hotel-castello-di-casole-a-timbers-resort",
  "/showcase/hotel-castle-fragsburg",
  "/showcase/hotel-le-fontanelle",
  "/showcase/hotel-president-wilson",
  "/showcase/hotel-tresanton",
  "/showcase/hotel-villa-il-patriarca",
  "/showcase/hurlingham-club",
  "/showcase/hylands-estate",
  "/showcase/iamflower",
  "/showcase/ikigaii-planners",
  "/showcase/il-falconiere",
  "/showcase/il-giorno-perfetto-glenda-marradi",
  "/showcase/il-salviatino-florence",
  "/showcase/ilmiomatrimonio-mywedinitaly",
  "/showcase/in-water-flowers",
  "/showcase/infinity-studio-italy",
  "/showcase/infinity-weddings",
  "/showcase/intercontinental-london-park-lane",
  "/showcase/inverlochy-castle-hotel",
  "/showcase/iole-criscitiello",
  "/showcase/iris-orangerie",
  "/showcase/iscoyd-park",
  "/showcase/italian-dream-weddings",
  "/showcase/italian-event-planners",
  "/showcase/italian-eye",
  "/showcase/italian-wedding-company",
  "/showcase/jamie-aston",
  "/showcase/jk-place-capri",
  "/showcase/joy-wedding-federica-tamborini",
  "/showcase/jumeirah-port-soller",
  "/showcase/jumeirah-zabeel-saray",
  "/showcase/jw-marriott-venice",
  "/showcase/kaleidos-wedding",
  "/showcase/kasbah-des-caids",
  "/showcase/kazamor-ibiza",
  "/showcase/kempinski-palace-engelberg",
  "/showcase/kew-palace",
  "/showcase/khushi-the-makeup-artist",
  "/showcase/kimpton-bem-budapest",
  "/showcase/la-bottega-del-sogno",
  "/showcase/la-calla-events",
  "/showcase/la-corte-dei-papi-relais-spa-restaurant",
  "/showcase/la-maltese",
  "/showcase/la-mamounia",
  "/showcase/la-plage",
  "/showcase/la-posta-vecchia-hotel",
  "/showcase/lada-fiori",
  "/showcase/lafodia",
  "/showcase/lake-country-house",
  "/showcase/lake-maggiore-wedding-style",
  "/showcase/landana",
  "/showcase/le-reve",
  "/showcase/le-torri-di-bagnara-castles",
  "/showcase/leeds-castle",
  "/showcase/leez-priory",
  "/showcase/leo-eventi",
  "/showcase/lichtag-photography",
  "/showcase/light-and-dreams",
  "/showcase/lights-and-magic",
  "/showcase/lillibrooke-manor",
  "/showcase/lina-and-tom-photography",
  "/showcase/lisa-semenzato",
  "/showcase/long-bay-beach-resort",
  "/showcase/lorella-giannini",
  "/showcase/lough-eske-castle",
  "/showcase/lovexposed-photography",
  "/showcase/lovexposed-photography-preview",
  "/showcase/loviu-events",
  "/showcase/loxus-hair-and-makeup",
  "/showcase/luz-houses",
  "/showcase/lythe-hill",
  "/showcase/ma-ca-casa-privata",
  "/showcase/magnolia-wedding-planner",
  "/showcase/makeup-by-mirna",
  "/showcase/mandarin-oriental-doha",
  "/showcase/mandarin-oriental-hyde-park",
  "/showcase/manowce-palace",
  "/showcase/marco-ficili",
  "/showcase/maria-luisa-rocchi-flowers",
  "/showcase/marica-events",
  "/showcase/marita-campanella",
  "/showcase/mas-huix",
  "/showcase/mas-torroella-luxury-villa-spa",
  "/showcase/masia-cabellut",
  "/showcase/masia-victoria",
  "/showcase/masseria-don-luigi",
  "/showcase/mastropa-exclusive-resort",
  "/showcase/matteo-cuzzola-photography",
  "/showcase/mauro-pozzer-photography",
  "/showcase/mcqueens-flowers",
  "/showcase/med-instyle",
  "/showcase/meissa-eventi",
  "/showcase/mgda-events",
  "/showcase/michele-monasta-photography",
  "/showcase/micklefield-hall",
  "/showcase/mirko-zago-sparkling-weddings",
  "/showcase/mons-calpe-suite",
  "/showcase/montagu-arms-hotel",
  "/showcase/more-than-weddings",
  "/showcase/mr-and-mrs-wedding-in-italy",
  "/showcase/mr-music-italy",
  "/showcase/my-lake-como-wedding",
  "/showcase/my-sicilian-wedding",
  "/showcase/my-sicily-wedding",
  "/showcase/nadine-pyke",
  "/showcase/naido-wedding",
  "/showcase/naka-island-phuket",
  "/showcase/natasha-barbato",
  "/showcase/nino-lombardo-photography",
  "/showcase/noemi-wedding",
  "/showcase/nozze-da-film",
  "/showcase/nunsmere-hall-hotel",
  "/showcase/nutfield-priory",
  "/showcase/o-sarracino-events",
  "/showcase/oheka-castle",
  "/showcase/old-course-hotel",
  "/showcase/one-marylebone",
  "/showcase/one-only-royal-mirage",
  "/showcase/orchardleigh-house-uk",
  "/showcase/ortica-wedding",
  "/showcase/over-yonder-cay",
  "/showcase/palais-ronsard",
  "/showcase/palazzetto-rosso",
  "/showcase/palazzo-ducale-di-avella-e-anfiteatro-romano",
  "/showcase/palazzo-suriano-heritage-hotel",
  "/showcase/pangiunia-wedding",
  "/showcase/paola-de-paola-photography",
  "/showcase/paola-lapi-luxury-event",
  "/showcase/paolo-cicognani",
  "/showcase/parade-wedding-event-planner",
  "/showcase/paradis-pietrasanta",
  "/showcase/park-hotel-ai-cappuccini",
  "/showcase/patrizia-cilli-events",
  "/showcase/peckforton-castle",
  "/showcase/pentillie-castle",
  "/showcase/petr-pelucha-photography",
  "/showcase/photomad",
  "/showcase/pierpaolo-perri",
  "/showcase/pino-coduti-photography",
  "/showcase/podere-castellare",
  "/showcase/pometti-estate-villa-boscarello",
  "/showcase/pura-vida-beach-ibiza",
  "/showcase/pure-house-ibiza",
  "/showcase/raffles-doha",
  "/showcase/ramona-avitabile-wedding-planner",
  "/showcase/rebecca-mays",
  "/showcase/reflexion-studio",
  "/showcase/relais-la-costa-tuscany",
  "/showcase/relais-santa-croce",
  "/showcase/rellini-art-studio",
  "/showcase/reserva-conchal",
  "/showcase/retreat-east",
  "/showcase/ritz-carlton-dubai",
  "/showcase/ritz-carlton-maldives-fari-islands",
  "/showcase/roberta-torresan",
  "/showcase/rocabella",
  "/showcase/rocabella-french-riviera",
  "/showcase/rocco-daniele-photography",
  "/showcase/rocks-the-room",
  "/showcase/roras-destination-wedding",
  "/showcase/rosecliff",
  "/showcase/rosewood-doha",
  "/showcase/royal-mansour-marrakech",
  "/showcase/rushton-hall-hotel-spa",
  "/showcase/saint-john-mykonos",
  "/showcase/samantha-pretto",
  "/showcase/samuel-lippke-studios",
  "/showcase/san-pietro-wedding",
  "/showcase/sanda-pandza-events",
  "/showcase/sandals-royal-caribbean",
  "/showcase/sara-dangelo",
  "/showcase/savoy-hotel-spa-paestum",
  "/showcase/say-yes-in-italy",
  "/showcase/shangri-la-the-shard",
  "/showcase/shilpa-reddy",
  "/showcase/shimmering-ivory",
  "/showcase/siari-riviera-nayarit",
  "/showcase/sicilian-wedding-day",
  "/showcase/sif-jakobs-jewellery",
  "/showcase/silavadee",
  "/showcase/silvia-cleri-photography",
  "/showcase/simone-perini-photography",
  "/showcase/six-senses-kaplankaya",
  "/showcase/six-senses-krabey-island",
  "/showcase/six-senses-laamu",
  "/showcase/six15-events",
  "/showcase/ski-hotel-maiensee",
  "/showcase/sophisticated-weddings",
  "/showcase/sorcha-herbert",
  "/showcase/sparx-wedding",
  "/showcase/spencer-house",
  "/showcase/sposa-mediterranea",
  "/showcase/st-regis-punta-mita",
  "/showcase/stefano-lunardi-photography",
  "/showcase/stella-and-moscha",
  "/showcase/story-of-your-day",
  "/showcase/strawberry-hill-house",
  "/showcase/strmol-castle",
  "/showcase/stuart-wood-photography",
  "/showcase/stubton-hall",
  "/showcase/studio-fotografico-bacci",
  "/showcase/studio27-by-andreas-politis",
  "/showcase/suellen-fernandes-weddings",
  "/showcase/susafa",
  "/showcase/sweet-pea-floral-design",
  "/showcase/swinton-park",
  "/showcase/swissotel-bosphorus-istanbul",
  "/showcase/syon-park",
  "/showcase/tai-flora-luxe",
  "/showcase/tan-house-newland",
  "/showcase/taormina-weddings",
  "/showcase/temperley-london",
  "/showcase/tenuta-pinto",
  "/showcase/tenuta-san-masseo",
  "/showcase/test-island-showcase",
  "/showcase/that-amazing-place",
  "/showcase/the-augustine-prague",
  "/showcase/the-berkeley",
  "/showcase/the-britannique",
  "/showcase/the-chateau-spa",
  "/showcase/the-chedi-lustica-bay",
  "/showcase/the-cotton-house",
  "/showcase/the-courti-estate",
  "/showcase/the-dorchester",
  "/showcase/the-elvetham",
  "/showcase/the-function-band",
  "/showcase/the-george-in-rye",
  "/showcase/the-goring",
  "/showcase/the-greenhouses",
  "/showcase/the-gritti-palace",
  "/showcase/the-hotel-cala-di-volpe-a-luxury-collection-hotel",
  "/showcase/the-kayon-ubud-resort",
  "/showcase/the-kayon-valley-resort-ubud",
  "/showcase/the-knot-in-italy",
  "/showcase/the-london-edition",
  "/showcase/the-mallorca-wedding-company",
  "/showcase/the-post-barn",
  "/showcase/the-ritz-carlton-abama",
  "/showcase/the-ritz-london",
  "/showcase/the-savoy",
  "/showcase/the-st-regis-florence",
  "/showcase/the-st-regis-rome",
  "/showcase/the-studio-without-walls",
  "/showcase/the-taaras-beach-spa-resort",
  "/showcase/the-wallace-collection",
  "/showcase/the-westin-excelsior-rome",
  "/showcase/thornbury-castle",
  "/showcase/tintswalo-atlantic",
  "/showcase/tissington-hall",
  "/showcase/tomas-de-bruyne",
  "/showcase/torre-collevento",
  "/showcase/torre-del-parco",
  "/showcase/tudor-barn-eltham",
  "/showcase/tuscan-dmc",
  "/showcase/umbria-weddings-and-events",
  "/showcase/un-giorno-un-sogno",
  "/showcase/upper-house-hayfield",
  "/showcase/valentines-mansion",
  "/showcase/valle-dellaquila",
  "/showcase/vanderbilt-estate",
  "/showcase/vic-rivero-films",
  "/showcase/victoria-amrose-photography",
  "/showcase/vila-bled",
  "/showcase/villa-agape",
  "/showcase/villa-balke",
  "/showcase/villa-cariola",
  "/showcase/villa-castiglione",
  "/showcase/villa-catalina",
  "/showcase/villa-darte-wedding",
  "/showcase/villa-del-vecchio-pozzo-in-posillipo",
  "/showcase/villa-di-catignano",
  "/showcase/villa-gallici-deciani",
  "/showcase/villa-il-cerretino",
  "/showcase/villa-la-rondinaia",
  "/showcase/villa-la-tosca",
  "/showcase/villa-macakizi-bodrum",
  "/showcase/villa-mangiacane",
  "/showcase/villa-michaela-tuscany",
  "/showcase/villa-nascosta",
  "/showcase/villa-nena",
  "/showcase/villa-pace",
  "/showcase/villa-paola-tropea",
  "/showcase/villa-ponta-melagrana",
  "/showcase/villa-punto-de-vista",
  "/showcase/villa-sofia",
  "/showcase/villa-susanna",
  "/showcase/villa-sylva",
  "/showcase/volvoreta-photography",
  "/showcase/wa-lab-events",
  "/showcase/waddesdon-manor",
  "/showcase/waldorf-astoria-maldives",
  "/showcase/wedding-cyprus-villas",
  "/showcase/wedding-hair-and-makeup-by-lisa",
  "/showcase/weddings-amalfi",
  "/showcase/wem-eventi",
  "/showcase/westin-valencia",
  "/showcase/white-emotion",
  "/showcase/whitesfilm-wedding-videography",
  "/showcase/wickham-house",
  "/showcase/wildabout",
  "/showcase/worstead-estate",
  "/showcase/wyck-hill-house",
  "/showcase/xo-cape-arnna",
  "/showcase/ycona",
  "/showcase/yervant-international",
  "/showcase/your-secret-tuscany",
  "/showcase/zita-elze",
  "/showcase/znaharchuk-studio"
];

export const editorialPaths = [
  "/lwd-edit/116-pall-mall-wedding-venue-st-jamess-london",
  "/lwd-edit/20-years-at-the-barns-at-delbury-hall",
  "/lwd-edit/abbazia-san-faustino-wedding-venue-umbria",
  "/lwd-edit/adare-manor-wedding-venue-ireland",
  "/lwd-edit/agriturismo-cima-alla-serra-wedding-venue-pisa",
  "/lwd-edit/alessandro-mari-photography-umbria-wedding-photographer",
  "/lwd-edit/alfonso-lorenzetto-wedding-photographer-treviso-veneto",
  "/lwd-edit/alila-manggis-wedding-venue-manggis-bali",
  "/lwd-edit/alila-ubud-wedding-venue-ubud-bali",
  "/lwd-edit/allerton-castle-wedding-venue-north-yorkshire",
  "/lwd-edit/amagatay-menorca-wedding-venue-menorca",
  "/lwd-edit/amalfi-coast-what-to-wear-three-looks",
  "/lwd-edit/aman-resorts-private-honeymoon",
  "/lwd-edit/amanpuris-villas",
  "/lwd-edit/amberley-castle-wedding-venue-west-sussex",
  "/lwd-edit/amie-bone-flowers-luxury-wedding-florist-hertfordshire",
  "/lwd-edit/andrea-federica-umbria-wedding-photographers",
  "/lwd-edit/andrea-gallucci-photography-amalfi-coast-wedding-photographer-ravello",
  "/lwd-edit/andreas-markakis-photography-chania-crete-wedding-photographer",
  "/lwd-edit/andrei-weddings-wedding-videographer-london",
  "/lwd-edit/angel-lion-weddings-wedding-planner-venice",
  "/lwd-edit/angela-salzano-destination-wedding-planner-italy-malta",
  "/lwd-edit/anita-galafate-wedding-planner-rome-italy",
  "/lwd-edit/anna-rosa-makeup-italy-bridal-makeup-artist-naples-campania",
  "/lwd-edit/armani-hotel-dubai-wedding-venue-dubai",
  "/lwd-edit/aston-band-wedding-entertainment-london",
  "/lwd-edit/atholl-palace-wedding-venue-pitlochry-perthshire",
  "/lwd-edit/auberge-du-soleil-wedding-venue-napa-valley-rutherford",
  "/lwd-edit/auckland-castle-wedding-venue-county-durham",
  "/lwd-edit/baglioni-cala-del-porto-wedding-venue-tuscany",
  "/lwd-edit/bali-wedding-venues-villas-pricing-capacity",
  "/lwd-edit/ballium-luxury-relais-wedding-venue-sicily-italy",
  "/lwd-edit/barbara-zanon-photography-venice-wedding-photographer",
  "/lwd-edit/bay-tree-hotel-burford-wedding-venue-burford-oxfordshire",
  "/lwd-edit/beatrice-espinosa-bridal-bespoke-wedding-dress-designer-hampshire",
  "/lwd-edit/beatrice-marco-lake-como-wedding",
  "/lwd-edit/becky-flynn-destination-bridal-makeup-artist-sussex",
  "/lwd-edit/bella-sposa-wedding-planner-sorrento-amalfi-coast",
  "/lwd-edit/benham-park-exclusive-use-wedding-venue-berkshire",
  "/lwd-edit/best-castle-wedding-venues-uk",
  "/lwd-edit/best-tinted-moisturisers-glowy-smooth-skin",
  "/lwd-edit/beverly-wilshire-wedding-venue-beverly-hills",
  "/lwd-edit/bianco-bouquet-weddings-events-wedding-planner-florence-tuscany",
  "/lwd-edit/bickleigh-castle-wedding-venue-devon",
  "/lwd-edit/birdsall-house-exclusive-use-wedding-venue-north-yorkshire",
  "/lwd-edit/blenheim-palace-wedding-venue-oxfordshire",
  "/lwd-edit/bodrum-edition-wedding-venue-bodrum",
  "/lwd-edit/bona-dea-wedding-venue-hermanus",
  "/lwd-edit/borgo-antichi-orti-assisi-wedding-venue-assisi",
  "/lwd-edit/borgo-bucciano-wedding-venue-san-miniato",
  "/lwd-edit/borgo-di-recenza-wedding-venue-siena",
  "/lwd-edit/borthwick-castle-wedding-venue-scotland",
  "/lwd-edit/boscolo-exedra-roma-wedding-venue-rome",
  "/lwd-edit/botias-hair-and-makeup-luxury-bridal-hair-makeup-essex",
  "/lwd-edit/bottega-dei-fiori-luxury-wedding-florist-florence-tuscany",
  "/lwd-edit/bovey-castle-wedding-venue-dartmoor",
  "/lwd-edit/briery-hill-house-wedding-venue-gloucestershire",
  "/lwd-edit/broadoaks-country-house-wedding-venue-windermere-lake-district",
  "/lwd-edit/brympton-house-wedding-venue-somerset",
  "/lwd-edit/burgenstock-resort-wedding-venue-lake-lucerne",
  "/lwd-edit/burlamacchi-villas-wedding-venue-tuscany",
  "/lwd-edit/bury-court-wedding-venue-surrey",
  "/lwd-edit/ca-sagredo-wedding-venue-venice",
  "/lwd-edit/can-lluc-hotel-wedding-venue-ibiza",
  "/lwd-edit/can-riera-de-la-pineda-wedding-venue-girona",
  "/lwd-edit/captains-club-hotel-riverside-wedding-venue-dorset",
  "/lwd-edit/casa-nova-estate-wedding-venue-sitges",
  "/lwd-edit/casale-de-pasquinelli-wedding-venue-lucca",
  "/lwd-edit/castel-monastero-resort-wedding-venue-siena",
  "/lwd-edit/castell-son-claret-wedding-venue-mallorca",
  "/lwd-edit/castello-bevilacqua-wedding-venue-verona",
  "/lwd-edit/castello-di-collegno-wedding-venue-turin",
  "/lwd-edit/castello-di-montignano-wedding-venue-umbria",
  "/lwd-edit/castello-di-petrata-wedding-venue-assisi",
  "/lwd-edit/castello-di-solfagnano-wedding-venue-perugia",
  "/lwd-edit/casterton-grange-wedding-venue-cumbria",
  "/lwd-edit/caswell-house-wedding-venue-oxfordshire",
  "/lwd-edit/chabil-mar-wedding-venue-belize",
  "/lwd-edit/chantal-flores-design-luxury-wedding-florist-west-london",
  "/lwd-edit/chateau-de-cheronne-chateau-wedding-venue-sarthe-france",
  "/lwd-edit/chateau-wedding-venues-france",
  "/lwd-edit/chewton-glen-wedding-venue-hampshire",
  "/lwd-edit/cinema-of-poetry-wedding-videographer-greece-italy",
  "/lwd-edit/ciragan-palace-kempinski-wedding-venue-istanbul",
  "/lwd-edit/claridges-wedding-venue-mayfair-london",
  "/lwd-edit/clearwell-castle-wedding-venue-gloucestershire",
  "/lwd-edit/cliveden-house-wedding-venue-berkshire",
  "/lwd-edit/cluny-castle-wedding-venue-aberdeenshire",
  "/lwd-edit/collegio-alla-querce-wedding-venue-florence",
  "/lwd-edit/collemassari-wedding-venue-maremma",
  "/lwd-edit/cortes-house-wedding-venue-aberdeenshire",
  "/lwd-edit/coworth-park-natural-luxury-wedding-venue-ascot",
  "/lwd-edit/creeksea-place-wedding-venue-burnham-on-crouch-essex",
  "/lwd-edit/crockwell-farm-wedding-venue-northamptonshire",
  "/lwd-edit/cromlix-wedding-venue-dunblane-perthshire",
  "/lwd-edit/daniele-vertelli-photography-florence-tuscany-wedding-photographer",
  "/lwd-edit/daria-events-destination-wedding-planner-switzerland",
  "/lwd-edit/dario-varsalona-wedding-event-designer-naples",
  "/lwd-edit/de-vere-horsley-estate-wedding-venue-surrey",
  "/lwd-edit/denee-motion-wedding-videographer-london-worldwide",
  "/lwd-edit/denise-more-wedding-planner-rome-italy",
  "/lwd-edit/design-led-weddings",
  "/lwd-edit/destination-wedding-cost-europe-country-breakdown",
  "/lwd-edit/detito-photography-amalfi-coast-wedding-photographer",
  "/lwd-edit/diego-giusti-photographer-tuscany-wedding-photographer",
  "/lwd-edit/dimas-frolov-photography-lisbon-wedding-photographer",
  "/lwd-edit/discover-japan-with-aman",
  "/lwd-edit/donna-camilla-savelli-hotel-wedding-venue-rome",
  "/lwd-edit/down-for-the-count-swing-jazz-band-london",
  "/lwd-edit/dream-on-wedding-team-wedding-planner-umbria-italy",
  "/lwd-edit/ds-studiofotografico-sicily-wedding-photographer",
  "/lwd-edit/duke-photography-los-angeles-wedding-photographer",
  "/lwd-edit/dundas-castle-wedding-venue-edinburgh",
  "/lwd-edit/dwp-congress-macao-2026",
  "/lwd-edit/el-martinete-villa-wedding-venue-marbella",
  "/lwd-edit/elisa-prati-wedding-italy-wedding-planner-lake-como-italy",
  "/lwd-edit/elisabetta-cardani-luxury-wedding-florist-lombardy",
  "/lwd-edit/elizabeth-hsieh-bridal-editorial-makeup-artist-london",
  "/lwd-edit/elizabeth-marsh-floral-design-luxury-wedding-florist-new-covent-garden-london",
  "/lwd-edit/elmore-court-wedding-venue-gloucestershire",
  "/lwd-edit/eltham-palace-wedding-venue-london",
  "/lwd-edit/emett-joseph-photography-seattle-wedding-photographer",
  "/lwd-edit/emma-jane-photography-london-cotswolds-wedding-photographer",
  "/lwd-edit/esplanade-boutique-hotel-paestum-wedding-venue-paestum",
  "/lwd-edit/ester-chianelli-weddings-events-wedding-planner-naples-italy",
  "/lwd-edit/eventilab-weddings-wedding-planner-rome-italy",
  "/lwd-edit/farbridge-wedding-venue-west-sussex",
  "/lwd-edit/farima-perry-luxury-wedding-florist-fitzroy-street-london",
  "/lwd-edit/farnham-castle-wedding-venue-surrey",
  "/lwd-edit/ferdinand-couturier-of-naples",
  "/lwd-edit/finca-delica-wedding-venue-ibiza",
  "/lwd-edit/finca-la-concertista-wedding-venue-penedes-catalonia",
  "/lwd-edit/finca-morneta-wedding-venue-mallorca",
  "/lwd-edit/fiori-amore-e-fantasia-luxury-wedding-florist-rome-italy",
  "/lwd-edit/flavia-bruni-luxury-wedding-florist-rome-italy",
  "/lwd-edit/fleurs-design-by-faustine-luxury-wedding-florist-montpellier-south-of-france",
  "/lwd-edit/floreventi-luxury-wedding-florist-rome-italy",
  "/lwd-edit/flower-station-wedding-florist-marylebone-london",
  "/lwd-edit/four-seasons-marrakech-wedding-venue-marrakech",
  "/lwd-edit/fowey-hall-wedding-venue-cornwall",
  "/lwd-edit/foxgloves-and-roses-fine-art-wedding-florist-oxfordshire",
  "/lwd-edit/francis-flowers-luxury-wedding-florist-florence-italy",
  "/lwd-edit/frutt-mountain-resort-wedding-venue-switzerland",
  "/lwd-edit/fulham-palace-wedding-venue-london",
  "/lwd-edit/gaetano-di-giacomo-media-production-wedding-videographer-uk-italy",
  "/lwd-edit/galu-seaside-wedding-venue-cyprus",
  "/lwd-edit/garini-immagina-eventi-wedding-designer-milan-italy",
  "/lwd-edit/getting-married-in-tuscany",
  "/lwd-edit/getting-married-in-umbria",
  "/lwd-edit/getting-married-on-lake-como",
  "/lwd-edit/giandomenico-cosentino-photography-genoa-wedding-photographer",
  "/lwd-edit/girls-international-wedding-band-london",
  "/lwd-edit/giuliano-bausano-rome-wedding-photographer",
  "/lwd-edit/giuseppe-suma-weddings-wedding-photographer-puglia-italy",
  "/lwd-edit/glam-events-in-tuscany-wedding-planner-tuscany-italy",
  "/lwd-edit/gordon-wedding-films-wedding-videographer-provence",
  "/lwd-edit/gorgeous-films-wedding-videographer-dorset-france",
  "/lwd-edit/grand-hotel-pianeta-maratea-resort-wedding-venue-maratea",
  "/lwd-edit/greek-island-weddings-beyond-santorini",
  "/lwd-edit/greystone-mansion-historic-wedding-venue-beverly-hills-los-angeles",
  "/lwd-edit/greywalls-hotel-chez-roux-wedding-venue-east-lothian",
  "/lwd-edit/grotta-giusti-thermal-spa-resort-wedding-venue-monsummano-terme",
  "/lwd-edit/hampton-court-palace-wedding-venue-surrey",
  "/lwd-edit/hampton-manor-wedding-venue-west-midlands",
  "/lwd-edit/harlaxton-manor-wedding-venue-lincolnshire",
  "/lwd-edit/haselbury-mill-wedding-venue-somerset",
  "/lwd-edit/haymarket-hotel-wedding-venue-london",
  "/lwd-edit/hd-moments-wedding-videographer-london",
  "/lwd-edit/hedsor-house-wedding-venue-buckinghamshire",
  "/lwd-edit/hengrave-hall-wedding-venue-suffolk",
  "/lwd-edit/hever-castle-wedding-venue-kent",
  "/lwd-edit/hillsborough-castle-wedding-venue-northern-ireland",
  "/lwd-edit/honeymoon-on-the-amalfi-coast",
  "/lwd-edit/horn-of-plenty-wedding-venue-tavistock-devon",
  "/lwd-edit/hotel-alpha-wedding-venue-sorrento",
  "/lwd-edit/hotel-bel-air-wedding-venue-bel-air-los-angeles",
  "/lwd-edit/hotel-castello-di-casole-a-timbers-resort-wedding-venue-siena",
  "/lwd-edit/hotel-de-la-ville-rome-wedding-venue-rome",
  "/lwd-edit/hotel-la-palma-wedding-venue-capri",
  "/lwd-edit/hotel-le-fontanelle-wedding-venue-siena",
  "/lwd-edit/hotel-president-wilson-wedding-venue-geneva",
  "/lwd-edit/hotel-savoy-florence-wedding-venue-florence",
  "/lwd-edit/hotel-tresanton-wedding-venue-cornwall",
  "/lwd-edit/hotel-villa-il-patriarca-wedding-venue-chiusi",
  "/lwd-edit/hurlingham-club-wedding-venue-london",
  "/lwd-edit/hylands-estate-wedding-venue-essex",
  "/lwd-edit/iamflower-luxury-wedding-florist-phuket-thailand",
  "/lwd-edit/il-falconiere-wedding-venue-cortona",
  "/lwd-edit/il-giorno-perfetto-glenda-marradi-wedding-planner-versilia-tuscany",
  "/lwd-edit/il-salviatino-florence-wedding-venue-florence",
  "/lwd-edit/in-water-flowers-luxury-wedding-florist-latimer-road-london",
  "/lwd-edit/infinity-studio-italy-amalfi-coast-wedding-photographer",
  "/lwd-edit/infinity-weddings-wedding-planner-tuscany-florence-italy",
  "/lwd-edit/inside-villa-del-balbianello",
  "/lwd-edit/inside-villa-deste-lake-como",
  "/lwd-edit/inside-worlds-most-prestigious-wedding-fair",
  "/lwd-edit/inverlochy-castle-hotel-wedding-venue-scottish-highlands",
  "/lwd-edit/iole-criscitiello-luxury-wedding-planner-amalfi-coast-naples",
  "/lwd-edit/iscoyd-park-wedding-venue-shropshire",
  "/lwd-edit/italian-dream-weddings-wedding-planner-bologna-italy",
  "/lwd-edit/italian-event-planners-destination-wedding-planner-amalfi-coast-italy",
  "/lwd-edit/italian-eye-luxury-event-designer-tuscany-london",
  "/lwd-edit/italian-wedding-company-wedding-planner-lake-orta-piedmont",
  "/lwd-edit/jamie-aston-luxury-wedding-florist-hackney-london",
  "/lwd-edit/japan-april-honeymoon-guide",
  "/lwd-edit/jk-place-capri-wedding-venue-capri",
  "/lwd-edit/joy-wedding-federica-tamborini-wedding-planner-central-italy",
  "/lwd-edit/jumeirah-port-soller-wedding-venue-mallorca",
  "/lwd-edit/jw-marriott-venice-wedding-venue-venice",
  "/lwd-edit/kaleidos-wedding-ibiza-wedding-photographer",
  "/lwd-edit/kasbah-des-caids-wedding-venue-draa-valley",
  "/lwd-edit/kazamor-ibiza-wedding-venue-ibiza",
  "/lwd-edit/kempinski-palace-engelberg-wedding-venue-swiss-alps",
  "/lwd-edit/kew-palace-wedding-venue-kew-surrey",
  "/lwd-edit/khushi-the-makeup-artist-south-asian-bridal-makeup-artist-london",
  "/lwd-edit/kimpton-bem-budapest-wedding-venue-budapest",
  "/lwd-edit/la-bottega-del-sogno-wedding-planner-tuscany-puglia-italy",
  "/lwd-edit/la-calla-events-wedding-planner-amalfi-coast",
  "/lwd-edit/la-corte-dei-papi-relais-spa-restaurant-wedding-venue-cortona",
  "/lwd-edit/la-maltese-wedding-venue-santorini",
  "/lwd-edit/la-plage-wedding-venue-taormina-sicily",
  "/lwd-edit/lada-fiori-luxury-wedding-florist-lake-como-italy",
  "/lwd-edit/lafodia-wedding-venue-croatia",
  "/lwd-edit/lake-country-house-wedding-venue-mid-wales",
  "/lwd-edit/lake-maggiore-wedding-style-wedding-planner-lake-maggiore-stresa",
  "/lwd-edit/landana-wedding-venue-maremma",
  "/lwd-edit/larry-walshe-luxury-wedding-florist-london",
  "/lwd-edit/le-reve-wedding-planner-rome-jewish-multicultural",
  "/lwd-edit/le-torri-di-bagnara-castles-wedding-venue-perugia",
  "/lwd-edit/leeds-castle-wedding-venue-kent",
  "/lwd-edit/leez-priory-wedding-venue-essex",
  "/lwd-edit/leo-eventi-elopement-planner-italy",
  "/lwd-edit/lichtag-photography-lake-como-wedding-photographer",
  "/lwd-edit/light-and-dreams-destination-wedding-photographer-tuscany",
  "/lwd-edit/lights-and-magic-wedding-videographer-sri-lanka",
  "/lwd-edit/lillibrooke-manor-wedding-venue-berkshire",
  "/lwd-edit/lina-and-tom-photography-hertfordshire-destination-wedding-photographers",
  "/lwd-edit/lisa-semenzato-bridal-makeup-artist-hairstylist-venice",
  "/lwd-edit/locanda-in-tuscany-wedding-venue-tuscany",
  "/lwd-edit/locanda-la-raia-wedding-venue-piedmont",
  "/lwd-edit/long-bay-beach-resort-wedding-venue-tortola",
  "/lwd-edit/long-weekend-wedding-guide",
  "/lwd-edit/lorella-giannini-destination-bridal-makeup-artist-sydney",
  "/lwd-edit/lough-eske-castle-wedding-venue-donegal",
  "/lwd-edit/love-without-rules-kristine-stephen-puglia",
  "/lwd-edit/lovexposed-photography-wedding-photographer-hertfordshire",
  "/lwd-edit/loviu-events-wedding-planner-sicily-palermo",
  "/lwd-edit/loxus-hair-and-makeup-bridal-hair-makeup-artist-cardiff-wales",
  "/lwd-edit/luz-houses-wedding-venue-central-portugal",
  "/lwd-edit/lythe-hill-wedding-venue-surrey",
  "/lwd-edit/ma-ca-casa-privata-wedding-venue-praiano",
  "/lwd-edit/magnolia-wedding-planner-wedding-planner-florence-tuscany",
  "/lwd-edit/makeup-by-mirna-luxury-bridal-makeup-artist-hertfordshire-london",
  "/lwd-edit/mandarin-oriental-doha-wedding-venue-doha",
  "/lwd-edit/mandarin-oriental-hyde-park-wedding-venue-london",
  "/lwd-edit/manowce-palace-wedding-venue-poland",
  "/lwd-edit/marco-ficili-catania-sicily-wedding-photographer",
  "/lwd-edit/maria-luisa-rocchi-flowers-wedding-florist-piazza-euclide-rome",
  "/lwd-edit/marica-events-wedding-planner-palermo-sicily",
  "/lwd-edit/mas-huix-wedding-venue-girona",
  "/lwd-edit/mas-torroella-luxury-villa-spa-wedding-venue-costa-brava",
  "/lwd-edit/masia-cabellut-wedding-venue-tarragona",
  "/lwd-edit/masia-victoria-wedding-venue-sitges",
  "/lwd-edit/masseria-alchimia-wedding-venue-puglia",
  "/lwd-edit/matteo-cuzzola-photography-lake-como-wedding-photographer",
  "/lwd-edit/mauro-pozzer-photography-vicenza-venice-wedding-photographer",
  "/lwd-edit/mcqueens-flowers-luxury-wedding-florist-london",
  "/lwd-edit/med-instyle-wedding-planner-capri-amalfi-coast-naples",
  "/lwd-edit/meissa-eventi-wedding-planner-amalfi-coast-campania",
  "/lwd-edit/mgda-events-wedding-planner-rome-civil-unions",
  "/lwd-edit/michele-monasta-photography-florence-wedding-photographer",
  "/lwd-edit/micklefield-hall-wedding-venue-hertfordshire",
  "/lwd-edit/mirko-zago-sparkling-weddings-wedding-planner-verona-lake-garda",
  "/lwd-edit/mons-calpe-suite-wedding-venue-gibraltar",
  "/lwd-edit/montagu-arms-hotel-new-forest-wedding-venue-hampshire",
  "/lwd-edit/more-than-weddings-destination-wedding-planner-veneto-verona-venice",
  "/lwd-edit/mr-and-mrs-wedding-in-italy-amalfi-coast-and-puglia-wedding-planner",
  "/lwd-edit/mr-music-italy-live-wedding-music-italy",
  "/lwd-edit/my-lake-como-wedding-wedding-planner-lake-como-italy",
  "/lwd-edit/my-sicilian-wedding-wedding-planner-sicily-caltagirone",
  "/lwd-edit/my-sicily-wedding-wedding-planner-sicily",
  "/lwd-edit/nadine-pyke-wedding-hair-makeup-team-surrey",
  "/lwd-edit/naido-wedding-destination-wedding-planner-athens-greece",
  "/lwd-edit/naka-island-phuket-wedding-venue-phuket",
  "/lwd-edit/natasha-barbato-luxury-wedding-planner-casas-latinas",
  "/lwd-edit/nino-lombardo-photography-sicily-wedding-photographer",
  "/lwd-edit/noemi-wedding-wedding-planner-venice-northern-italy",
  "/lwd-edit/nozze-da-film-wedding-videographer-piedmont-italy",
  "/lwd-edit/nunsmere-hall-hotel-wedding-venue-cheshire",
  "/lwd-edit/nutfield-priory-wedding-venue-surrey",
  "/lwd-edit/o-sarracino-events-wedding-planner-procida-campania",
  "/lwd-edit/old-course-hotel-st-andrews-wedding-venue",
  "/lwd-edit/one-marylebone-wedding-venue-london",
  "/lwd-edit/one-only-royal-mirage-wedding-venue-dubai",
  "/lwd-edit/ortica-wedding-rome-wedding-photographers",
  "/lwd-edit/over-yonder-cay-wedding-venue-exuma-bahamas",
  "/lwd-edit/palazzetto-rosso-wedding-venue-tuscany",
  "/lwd-edit/palazzo-ducale-di-avella-e-anfiteatro-romano-wedding-venue-naples-campania",
  "/lwd-edit/palazzo-suriano-heritage-hotel-wedding-venue-amalfi-coast",
  "/lwd-edit/pangiunia-wedding-wedding-planner-catania-sicily",
  "/lwd-edit/paola-de-paola-photography-alternative-wedding-photographer-london",
  "/lwd-edit/paola-lapi-luxury-event-wedding-planner-taormina-sicily",
  "/lwd-edit/paolo-cicognani-wedding-planner-italy",
  "/lwd-edit/paradis-pietrasanta-wedding-venue-pietrasanta",
  "/lwd-edit/park-hotel-ai-cappuccini-wedding-venue-gubbio",
  "/lwd-edit/patrizia-cilli-events-wedding-planner-rome-global-production",
  "/lwd-edit/peckforton-castle-wedding-venue-cheshire",
  "/lwd-edit/pentillie-castle-wedding-venue-cornwall",
  "/lwd-edit/petr-pelucha-photography-prague-wedding-photographer",
  "/lwd-edit/photomad-athens-wedding-photographer",
  "/lwd-edit/pierpaolo-perri-amalfi-coast-wedding-photographer",
  "/lwd-edit/pino-coduti-photography-puglia-wedding-photographer",
  "/lwd-edit/podere-castellare-wedding-venue-tuscany",
  "/lwd-edit/pometti-estate-villa-boscarello-wedding-venue-siena",
  "/lwd-edit/pura-vida-beach-ibiza-wedding-venue-ibiza",
  "/lwd-edit/pure-house-ibiza-wedding-venue-ibiza",
  "/lwd-edit/raffles-doha-wedding-venue-doha",
  "/lwd-edit/ramona-avitabile-wedding-planner-amalfi-coast-wedding-planner-italy",
  "/lwd-edit/rebecca-mays-luxury-wedding-florist-london",
  "/lwd-edit/reflexion-studio-dubrovnik-croatia-wedding-photographer",
  "/lwd-edit/relais-la-costa-tuscany-wedding-venue-siena",
  "/lwd-edit/relais-santa-croce-wedding-venue-florence",
  "/lwd-edit/rellini-art-studio-wedding-photographer-umbria-tuscany",
  "/lwd-edit/retreat-east-wedding-venue-suffolk",
  "/lwd-edit/ritz-carlton-dubai-wedding-venue-dubai",
  "/lwd-edit/ritz-carlton-maldives-fari-islands-wedding-venue-maldives",
  "/lwd-edit/rocco-daniele-photography-calabria-wedding-photographer",
  "/lwd-edit/rocks-the-room-wedding-band-london",
  "/lwd-edit/roras-destination-wedding-wedding-planner-tuscany-ibiza",
  "/lwd-edit/rosecliff-gilded-age-wedding-venue-newport-rhode-island",
  "/lwd-edit/rosewood-doha-wedding-venue-doha",
  "/lwd-edit/royal-mansour-marrakech-wedding-venue-marrakech",
  "/lwd-edit/rushton-hall-hotel-spa-wedding-venue-northamptonshire",
  "/lwd-edit/samantha-pretto-destination-bridal-hair-makeup-lake-como",
  "/lwd-edit/samuel-lippke-studios-los-angeles-wedding-photographer",
  "/lwd-edit/san-pietro-wedding-wedding-venue-umbria",
  "/lwd-edit/sanda-pandza-events-wedding-planner-rome-italy",
  "/lwd-edit/sandals-royal-caribbean-wedding-venue-jamaica",
  "/lwd-edit/sara-dangelo-wedding-architect-naples-amalfi-coast",
  "/lwd-edit/savoy-hotel-spa-paestum-wedding-venue-paestum",
  "/lwd-edit/shangri-la-paris-wedding-venue-paris",
  "/lwd-edit/shangri-la-the-shard-wedding-venue-london",
  "/lwd-edit/shilpa-reddy-luxury-wedding-florist-london",
  "/lwd-edit/siari-riviera-nayarit-wedding-venue-riviera-nayarit-mexico",
  "/lwd-edit/sicilian-wedding-day-wedding-planner-messina-sicily",
  "/lwd-edit/sif-jakobs-jewellery-copenhagen-jewellery-house",
  "/lwd-edit/silavadee-wedding-venue-koh-samui",
  "/lwd-edit/silvia-cleri-photography-rome-wedding-photographer",
  "/lwd-edit/simone-perini-photography-florence-wedding-photographer",
  "/lwd-edit/six-senses-kaplankaya-wedding-venue-bodrum-turkey",
  "/lwd-edit/six-senses-laamu-wedding-venue-maldives",
  "/lwd-edit/six15-events-wedding-entertainment-lancashire",
  "/lwd-edit/ski-hotel-maiensee-wedding-venue-arlberg",
  "/lwd-edit/sophisticated-weddings-amalfi-coast-wedding-planner-sorrento",
  "/lwd-edit/sorcha-herbert-natural-wedding-florist-buckinghamshire",
  "/lwd-edit/sparx-wedding-wedding-planner-taormina-sicily",
  "/lwd-edit/spencer-house-wedding-venue-st-jamess-london",
  "/lwd-edit/sposa-mediterranea-wedding-planner-ravello-amalfi-coast",
  "/lwd-edit/st-regis-punta-mita-wedding-venue-riviera-nayarit",
  "/lwd-edit/stefano-lunardi-photography-austria-italy-wedding-photographer",
  "/lwd-edit/stella-and-moscha-greek-island-wedding-planners-santorini",
  "/lwd-edit/story-of-your-day-wedding-videographer-switzerland",
  "/lwd-edit/strawberry-hill-house-wedding-venue-london",
  "/lwd-edit/strmol-castle-wedding-venue-slovenia",
  "/lwd-edit/stuart-wood-photography-luxury-wedding-photographer-london",
  "/lwd-edit/stubton-hall-wedding-venue-lincolnshire",
  "/lwd-edit/studio-fotografico-bacci-florence-tuscany-wedding-photographer",
  "/lwd-edit/studio27-by-andreas-politis-corfu-wedding-photographer",
  "/lwd-edit/suellen-fernandes-weddings-destination-wedding-planner-veneto-italy",
  "/lwd-edit/susafa-wedding-venue-sicily",
  "/lwd-edit/sweet-pea-floral-design-luxury-wedding-florist-hackney-london",
  "/lwd-edit/swinton-park-wedding-venue-north-yorkshire",
  "/lwd-edit/swissotel-bosphorus-istanbul-wedding-venue-istanbul",
  "/lwd-edit/syon-park-wedding-venue-london",
  "/lwd-edit/tai-flora-luxe-luxury-wedding-florist-jamaica",
  "/lwd-edit/tan-house-newland-wedding-venue-forest-of-dean",
  "/lwd-edit/taormina-weddings-wedding-planner-taormina-sicily",
  "/lwd-edit/tenuta-pinto-wedding-venue-puglia",
  "/lwd-edit/tenuta-san-masseo-wedding-venue-assisi",
  "/lwd-edit/that-amazing-place-wedding-venue-essex",
  "/lwd-edit/the-art-of-the-amalfi-wedding",
  "/lwd-edit/the-augustine-prague-wedding-venue-prague",
  "/lwd-edit/the-berkeley-wedding-venue-knightsbridge-london",
  "/lwd-edit/the-britannique-wedding-venue-naples",
  "/lwd-edit/the-chedi-lustica-bay-wedding-venue-montenegro",
  "/lwd-edit/the-cotton-house-wedding-venue-mustique",
  "/lwd-edit/the-courti-estate-wedding-venue-corfu",
  "/lwd-edit/the-dorchester-park-lane-wedding-venue-london",
  "/lwd-edit/the-elvetham-wedding-venue-hampshire",
  "/lwd-edit/the-function-band-wedding-entertainment-london",
  "/lwd-edit/the-george-in-rye-wedding-venue-east-sussex",
  "/lwd-edit/the-goring-wedding-venue-london",
  "/lwd-edit/the-greenhouses-intimate-glasshouse-wedding-venue-london",
  "/lwd-edit/the-gritti-palace-wedding-venue-venice",
  "/lwd-edit/the-hotel-cala-di-volpe-a-luxury-collection-hotel-wedding-venue-porto-cervo",
  "/lwd-edit/the-kayon-valley-resort-ubud-wedding-venue-ubud-bali",
  "/lwd-edit/the-lanesborough-wedding-venue-hyde-park-corner-london",
  "/lwd-edit/the-london-edition-wedding-venue-london",
  "/lwd-edit/the-mallorca-wedding-company-wedding-planner-mallorca",
  "/lwd-edit/the-ned-wedding-venue-city-of-london",
  "/lwd-edit/the-quiet-revolution-of-italian-tailoring",
  "/lwd-edit/the-ritz-carlton-abama-wedding-venue-tenerife",
  "/lwd-edit/the-savoy-strand-wedding-venue-london",
  "/lwd-edit/the-st-regis-budapest-wedding-venue-budapest",
  "/lwd-edit/the-st-regis-florence-wedding-venue-florence",
  "/lwd-edit/the-st-regis-rome-wedding-venue-rome",
  "/lwd-edit/the-studio-without-walls-hertfordshire-wedding-photographer",
  "/lwd-edit/the-wallace-collection-wedding-venue-london",
  "/lwd-edit/the-wedding-weekend-revolution",
  "/lwd-edit/the-wellness-wedding",
  "/lwd-edit/the-westin-excelsior-rome-wedding-venue-rome",
  "/lwd-edit/thornbury-castle-wedding-venue-gloucestershire",
  "/lwd-edit/tintswalo-atlantic-wedding-venue-hout-bay-cape-town",
  "/lwd-edit/tissington-hall-wedding-venue-derbyshire",
  "/lwd-edit/tomas-de-bruyne-luxury-wedding-florist-belgium",
  "/lwd-edit/torre-collevento-wedding-venue-orvieto",
  "/lwd-edit/tudor-barn-eltham-wedding-venue-london",
  "/lwd-edit/tuscan-dmc-wedding-planner-siena-tuscany-italy",
  "/lwd-edit/umbria-weddings-and-events-wedding-planner-umbria-italy",
  "/lwd-edit/upper-house-hayfield-wedding-venue-peak-district",
  "/lwd-edit/valentines-mansion-wedding-venue-essex",
  "/lwd-edit/valle-dellaquila-wedding-venue-settefrati",
  "/lwd-edit/vic-rivero-films-wedding-videographer-surrey-london",
  "/lwd-edit/victoria-amrose-photography-shropshire-wedding-photographer",
  "/lwd-edit/villa-agape-wedding-venue-florence",
  "/lwd-edit/villa-balke-wedding-venue-naples",
  "/lwd-edit/villa-cariola-wedding-venue-lake-garda",
  "/lwd-edit/villa-castiglione-wedding-venue-florence",
  "/lwd-edit/villa-catalina-wedding-venue-sitges",
  "/lwd-edit/villa-darte-wedding-wedding-venue-florence",
  "/lwd-edit/villa-del-vecchio-pozzo-in-posillipo-wedding-venue-naples",
  "/lwd-edit/villa-di-catignano-wedding-venue-siena",
  "/lwd-edit/villa-gallici-deciani-wedding-venue-udine",
  "/lwd-edit/villa-il-cerretino-wedding-venue-florence",
  "/lwd-edit/villa-la-rondinaia-wedding-venue-amalfi-coast",
  "/lwd-edit/villa-mangiacane-florence-wedding-venue-florence",
  "/lwd-edit/villa-mangiacane-wedding-venue-florence",
  "/lwd-edit/villa-michaela-tuscany-wedding-venue-lucca",
  "/lwd-edit/villa-nascosta-wedding-venue-lake-como",
  "/lwd-edit/villa-nena-wedding-venue-marche",
  "/lwd-edit/villa-pace-wedding-venue-veneto",
  "/lwd-edit/villa-paola-tropea-wedding-venue-calabria",
  "/lwd-edit/villa-ponta-melagrana-wedding-venue-montenegro",
  "/lwd-edit/villa-sofia-wedding-venue-lecco",
  "/lwd-edit/villa-susanna-wedding-venue-st-lucia",
  "/lwd-edit/villa-sylva-wedding-venue-corfu",
  "/lwd-edit/volvoreta-photography-galicia-wedding-photographer",
  "/lwd-edit/wa-lab-events-wedding-planner-lombardy",
  "/lwd-edit/waddesdon-manor-wedding-venue-buckinghamshire",
  "/lwd-edit/waldorf-astoria-maldives-wedding-venue-maldives",
  "/lwd-edit/wedding-cyprus-villas-wedding-venue-paphos",
  "/lwd-edit/wedding-guest-dress-six-any-wedding-this-summer",
  "/lwd-edit/wedding-hair-and-makeup-by-lisa-bridal-hair-makeup-artist-southampton-hampshire",
  "/lwd-edit/wedding-south-of-france-venues-vendors-seasons",
  "/lwd-edit/weddings-amalfi-wedding-planner-amalfi-coast",
  "/lwd-edit/weddings-at-gordon-ramsay-restaurants",
  "/lwd-edit/wem-eventi-wedding-planner-naples-italy",
  "/lwd-edit/westin-valencia-wedding-venue-valencia",
  "/lwd-edit/white-emotion-wedding-planner-milan-italy",
  "/lwd-edit/whitesfilm-wedding-videography-wedding-videographer-venice-italy",
  "/lwd-edit/why-quiet-luxury-has-changed-destination-weddings",
  "/lwd-edit/wickham-house-wedding-venue-berkshire",
  "/lwd-edit/wildabout-luxury-wedding-florist-london",
  "/lwd-edit/woburn-abbey-sculpture-gallery-wedding-venue-bedfordshire",
  "/lwd-edit/worstead-estate-wedding-venue-north-norfolk",
  "/lwd-edit/wyck-hill-house-wedding-venue-cotswolds",
  "/lwd-edit/ycona-wedding-venue-zanzibar",
  "/lwd-edit/yervant-international-south-melbourne-wedding-photographer",
  "/lwd-edit/your-secret-tuscany-wedding-planner-tuscany-italy",
  "/lwd-edit/zita-elze-luxury-wedding-florist-kew-richmond",
  "/lwd-edit/znaharchuk-studio-wedding-videographer-france"
];

export const reviewPaths = [
  "/australia/melbourne/photographers/yervant-international/reviews",
  "/australia/sydney/hair-makeup/lorella-giannini/reviews",
  "/austria/carinthia/photographers/stefano-lunardi-photography/reviews",
  "/austria/tyrol/wedding-venues/grand-tirolia-kitzbuehel/reviews",
  "/austria/tyrol/wedding-venues/ski-hotel-maiensee/reviews",
  "/belgium/west-flanders/florists/tomas-de-bruyne/reviews",
  "/cambodia/preah-sihanouk/wedding-venues/six-senses-krabey-island/reviews",
  "/caribbean/jamaica/florists/tai-flora-luxe/reviews",
  "/costa-rica/guanacaste/wedding-venues/reserva-conchal/reviews",
  "/costa-rica/manuel-antonio/wedding-venues/villa-punto-de-vista/reviews",
  "/croatia/dubrovnik/photographers/reflexion-studio/reviews",
  "/cyprus/larnaca-ayia-napa/wedding-venues/galu-seaside/reviews",
  "/czech-republic/central-bohemia/wedding-venues/chateau-mcely/reviews",
  "/czech-republic/prague/photographers/petr-pelucha-photography/reviews",
  "/denmark/copenhagen/jewellers/sif-jakobs-jewellery/reviews",
  "/england/berkshire/wedding-venues/lillibrooke-manor/reviews",
  "/england/berkshire/wedding-venues/the-post-barn/reviews",
  "/england/buckinghamshire/florists/sorcha-herbert/reviews",
  "/england/buckinghamshire/wedding-venues/hedsor-house/reviews",
  "/england/buckinghamshire/wedding-venues/waddesdon-manor/reviews",
  "/england/cornwall/wedding-venues/fowey-hall/reviews",
  "/england/cornwall/wedding-venues/hotel-tresanton/reviews",
  "/england/cornwall/wedding-venues/pentillie-castle/reviews",
  "/england/county-durham/wedding-venues/auckland-castle/reviews",
  "/england/cumbria/wedding-venues/askham-hall/reviews",
  "/england/cumbria/wedding-venues/casterton-grange/reviews",
  "/england/derbyshire/wedding-venues/upper-house-hayfield/reviews",
  "/england/devon/wedding-venues/bickleigh-castle/reviews",
  "/england/devon/wedding-venues/horn-of-plenty/reviews",
  "/england/dorset/videographers/gorgeous-films/reviews",
  "/england/dorset/wedding-venues/captains-club-hotel/reviews",
  "/england/east-sussex/wedding-venues/the-george-in-rye/reviews",
  "/england/essex/hair-makeup/botias-hair-and-makeup/reviews",
  "/england/essex/wedding-venues/creeksea-place/reviews",
  "/england/essex/wedding-venues/hylands-estate/reviews",
  "/england/essex/wedding-venues/that-amazing-place/reviews",
  "/england/essex/wedding-venues/valentines-mansion/reviews",
  "/england/gloucestershire/wedding-venues/tan-house-newland/reviews",
  "/england/gloucestershire/wedding-venues/wyck-hill-house/reviews",
  "/england/hampshire/bridal-boutiques/beatrice-espinosa-bridal/reviews",
  "/england/hampshire/hair-makeup/wedding-hair-and-makeup-by-lisa/reviews",
  "/england/hampshire/wedding-venues/montagu-arms-hotel/reviews",
  "/england/hampshire/wedding-venues/the-elvetham/reviews",
  "/england/hertfordshire/florists/amie-bone-flowers/reviews",
  "/england/hertfordshire/hair-makeup/makeup-by-mirna/reviews",
  "/england/hertfordshire/photographers/lina-and-tom-photography/reviews",
  "/england/hertfordshire/photographers/lovexposed-photography/reviews",
  "/england/hertfordshire/videographers/gaetano-di-giacomo-media-production/reviews",
  "/england/hertfordshire/wedding-venues/micklefield-hall/reviews",
  "/england/lincolnshire/wedding-venues/harlaxton-manor/reviews",
  "/england/london/entertainment/aston-band/reviews",
  "/england/london/entertainment/rocks-the-room/reviews",
  "/england/london/entertainment/the-function-band/reviews",
  "/england/london/florists/rebecca-mays/reviews",
  "/england/london/florists/shilpa-reddy/reviews",
  "/england/london/florists/sweet-pea-floral-design/reviews",
  "/england/london/florists/wildabout/reviews",
  "/england/london/florists/zita-elze/reviews",
  "/england/london/hair-makeup/elizabeth-hsieh/reviews",
  "/england/london/hair-makeup/khushi-the-makeup-artist/reviews",
  "/england/london/photographers/emma-jane-photography/reviews",
  "/england/london/photographers/paola-de-paola-photography/reviews",
  "/england/london/photographers/stuart-wood-photography/reviews",
  "/england/london/videographers/andrei-weddings/reviews",
  "/england/london/videographers/denee-motion/reviews",
  "/england/london/videographers/hd-moments/reviews",
  "/england/london/wedding-planners/angela-salzano/reviews",
  "/england/london/wedding-venues/116-pall-mall/reviews",
  "/england/london/wedding-venues/one-marylebone/reviews",
  "/england/london/wedding-venues/strawberry-hill-house/reviews",
  "/england/london/wedding-venues/the-greenhouses/reviews",
  "/england/london/wedding-venues/the-london-edition/reviews",
  "/england/london/wedding-venues/tudor-barn-eltham/reviews",
  "/england/norfolk/wedding-venues/worstead-estate/reviews",
  "/england/north-yorkshire/wedding-venues/birdsall-house/reviews",
  "/england/northamptonshire/wedding-venues/crockwell-farm/reviews",
  "/england/northamptonshire/wedding-venues/rushton-hall-hotel-spa/reviews",
  "/england/oxfordshire/wedding-venues/bay-tree-hotel-burford/reviews",
  "/england/shropshire/photographers/victoria-amrose-photography/reviews",
  "/england/somerset/wedding-venues/haselbury-mill/reviews",
  "/england/suffolk/wedding-venues/retreat-east/reviews",
  "/england/surrey/hair-makeup/nadine-pyke/reviews",
  "/england/surrey/videographers/vic-rivero-films/reviews",
  "/england/surrey/wedding-venues/farnham-castle/reviews",
  "/england/west-sussex/hair-makeup/becky-flynn/reviews",
  "/england/west-sussex/wedding-venues/farbridge/reviews",
  "/france/arcachon-bay/wedding-venues/villa-la-tosca/reviews",
  "/france/bordeaux-and-aquitaine/wedding-venues/domaine-des-etangs/reviews",
  "/france/french-riviera/wedding-venues/chateau-saint-georges/reviews",
  "/france/ile-de-france/videographers/znaharchuk-studio/reviews",
  "/france/languedoc/florists/fleurs-design-by-faustine/reviews",
  "/france/loire-valley/wedding-venues/chateau-de-cheronne/reviews",
  "/france/provence/videographers/gordon-wedding-films/reviews",
  "/greece/athens/wedding-planners/naido-wedding/reviews",
  "/greece/attica/photographers/photomad/reviews",
  "/greece/attica/videographers/cinema-of-poetry/reviews",
  "/greece/corfu/photographers/studio27-by-andreas-politis/reviews",
  "/greece/crete/photographers/andreas-markakis-photography/reviews",
  "/greece/cyclades/wedding-venues/saint-john-mykonos/reviews",
  "/greece/santorini/wedding-planners/stella-and-moscha/reviews",
  "/ireland/donegal/wedding-venues/lough-eske-castle/reviews",
  "/italy/amalfi-coast/photographers/andrea-gallucci-photography/reviews",
  "/italy/amalfi-coast/photographers/infinity-studio-italy/reviews",
  "/italy/amalfi-coast/wedding-planners/bella-sposa/reviews",
  "/italy/amalfi-coast/wedding-planners/italian-event-planners/reviews",
  "/italy/amalfi-coast/wedding-planners/la-calla-events/reviews",
  "/italy/amalfi-coast/wedding-planners/mr-and-mrs-wedding-in-italy/reviews",
  "/italy/amalfi-coast/wedding-planners/ramona-avitabile-wedding-planner/reviews",
  "/italy/amalfi-coast/wedding-planners/sposa-mediterranea/reviews",
  "/italy/amalfi-coast/wedding-planners/weddings-amalfi/reviews",
  "/italy/calabria/photographers/rocco-daniele-photography/reviews",
  "/italy/campania/wedding-planners/dario-varsalona/reviews",
  "/italy/campania/wedding-planners/ester-chianelli-weddings-events/reviews",
  "/italy/campania/wedding-planners/med-instyle/reviews",
  "/italy/campania/wedding-planners/o-sarracino-events/reviews",
  "/italy/campania/wedding-planners/sara-dangelo/reviews",
  "/italy/campania/wedding-planners/wem-eventi/reviews",
  "/italy/campania/wedding-venues/esplanade-boutique-hotel-paestum/reviews",
  "/italy/campania/wedding-venues/savoy-hotel-spa-paestum/reviews",
  "/italy/campania/wedding-venues/villa-balke/reviews",
  "/italy/emilia-romagna/wedding-planners/italian-dream-weddings/reviews",
  "/italy/emilia-romagna/wedding-planners/joy-wedding-federica-tamborini/reviews",
  "/italy/emilia-romagna/wedding-planners/paolo-cicognani/reviews",
  "/italy/lake-como/florists/lada-fiori/reviews",
  "/italy/lake-como/hair-makeup/samantha-pretto/reviews",
  "/italy/lake-como/photographers/lichtag-photography/reviews",
  "/italy/lake-como/photographers/matteo-cuzzola-photography/reviews",
  "/italy/lake-como/wedding-planners/elisa-prati-wedding-italy/reviews",
  "/italy/lake-como/wedding-planners/my-lake-como-wedding/reviews",
  "/italy/lake-maggiore/wedding-planners/lake-maggiore-wedding-style/reviews",
  "/italy/lazio/wedding-venues/la-posta-vecchia-hotel/reviews",
  "/italy/liguria/photographers/giandomenico-cosentino-photography/reviews",
  "/italy/lombardy/wedding-planners/white-emotion/reviews",
  "/italy/piedmont/videographers/nozze-da-film/reviews",
  "/italy/piedmont/wedding-planners/italian-wedding-company/reviews",
  "/italy/piedmont/wedding-planners/leo-eventi/reviews",
  "/italy/piedmont/wedding-planners/un-giorno-un-sogno/reviews",
  "/italy/piedmont/wedding-venues/castello-di-collegno/reviews",
  "/italy/puglia/photographers/giuseppe-suma-weddings/reviews",
  "/italy/puglia/photographers/pino-coduti-photography/reviews",
  "/italy/puglia/wedding-venues/masseria-don-luigi/reviews",
  "/italy/puglia/wedding-venues/tenuta-pinto/reviews",
  "/italy/rome/entertainment/mr-music-italy/reviews",
  "/italy/rome/florists/fiori-amore-e-fantasia/reviews",
  "/italy/rome/florists/flavia-bruni/reviews",
  "/italy/rome/florists/floreventi/reviews",
  "/italy/rome/florists/maria-luisa-rocchi-flowers/reviews",
  "/italy/rome/photographers/giuliano-bausano/reviews",
  "/italy/rome/photographers/ortica-wedding/reviews",
  "/italy/rome/photographers/silvia-cleri-photography/reviews",
  "/italy/rome/wedding-planners/anita-galafate/reviews",
  "/italy/rome/wedding-planners/denise-more/reviews",
  "/italy/rome/wedding-planners/dream-weddings-by-francesca-resciniti/reviews",
  "/italy/rome/wedding-planners/eventilab-weddings/reviews",
  "/italy/rome/wedding-planners/ilmiomatrimonio-mywedinitaly/reviews",
  "/italy/rome/wedding-planners/le-reve/reviews",
  "/italy/rome/wedding-planners/mgda-events/reviews",
  "/italy/rome/wedding-planners/parade-wedding-event-planner/reviews",
  "/italy/rome/wedding-planners/roberta-torresan/reviews",
  "/italy/rome/wedding-planners/sanda-pandza-events/reviews",
  "/italy/rome/wedding-venues/donna-camilla-savelli-hotel/reviews",
  "/italy/sicily/photographers/ds-studiofotografico/reviews",
  "/italy/sicily/photographers/marco-ficili/reviews",
  "/italy/sicily/photographers/nino-lombardo-photography/reviews",
  "/italy/sicily/wedding-planners/loviu-events/reviews",
  "/italy/sicily/wedding-planners/marica-events/reviews",
  "/italy/sicily/wedding-planners/my-sicilian-wedding/reviews",
  "/italy/sicily/wedding-planners/my-sicily-wedding/reviews",
  "/italy/sicily/wedding-planners/pangiunia-wedding/reviews",
  "/italy/sicily/wedding-planners/paola-lapi-luxury-event/reviews",
  "/italy/sicily/wedding-planners/sicilian-wedding-day/reviews",
  "/italy/sicily/wedding-planners/sparx-wedding/reviews",
  "/italy/sicily/wedding-planners/taormina-weddings/reviews",
  "/italy/sicily/wedding-venues/susafa/reviews",
  "/italy/tuscany/florists/francis-flowers/reviews",
  "/italy/tuscany/photographers/diego-giusti-photographer/reviews",
  "/italy/tuscany/photographers/light-and-dreams/reviews",
  "/italy/tuscany/photographers/michele-monasta-photography/reviews",
  "/italy/tuscany/photographers/simone-perini-photography/reviews",
  "/italy/tuscany/photographers/studio-fotografico-bacci/reviews",
  "/italy/tuscany/wedding-planners/bianco-bouquet-weddings-events/reviews",
  "/italy/tuscany/wedding-planners/infinity-weddings/reviews",
  "/italy/tuscany/wedding-planners/la-bottega-del-sogno/reviews",
  "/italy/tuscany/wedding-planners/magnolia-wedding-planner/reviews",
  "/italy/tuscany/wedding-planners/roras-destination-wedding/reviews",
  "/italy/tuscany/wedding-planners/your-secret-tuscany/reviews",
  "/italy/tuscany/wedding-venues/borgo-bucciano/reviews",
  "/italy/tuscany/wedding-venues/burlamacchi-villas/reviews",
  "/italy/tuscany/wedding-venues/castel-monastero-resort/reviews",
  "/italy/tuscany/wedding-venues/grotta-giusti-thermal-spa-resort/reviews",
  "/italy/tuscany/wedding-venues/hotel-le-fontanelle/reviews",
  "/italy/tuscany/wedding-venues/palazzetto-rosso/reviews",
  "/italy/tuscany/wedding-venues/podere-castellare/reviews",
  "/italy/tuscany/wedding-venues/villa-mangiacane/reviews",
  "/italy/tuscany/wedding-venues/villa-michaela-tuscany/reviews",
  "/italy/umbria/photographers/alessandro-mari-photography/reviews",
  "/italy/umbria/photographers/andrea-federica/reviews",
  "/italy/umbria/photographers/rellini-art-studio/reviews",
  "/italy/umbria/wedding-planners/dream-on-wedding-team/reviews",
  "/italy/umbria/wedding-planners/umbria-weddings-and-events/reviews",
  "/italy/umbria/wedding-venues/castello-di-montignano/reviews",
  "/italy/umbria/wedding-venues/le-torri-di-bagnara-castles/reviews",
  "/italy/umbria/wedding-venues/san-pietro-wedding/reviews",
  "/italy/umbria/wedding-venues/tenuta-san-masseo/reviews",
  "/italy/umbria/wedding-venues/torre-collevento/reviews",
  "/italy/veneto/wedding-planners/mirko-zago-sparkling-weddings/reviews",
  "/italy/veneto/wedding-planners/more-than-weddings/reviews",
  "/italy/veneto/wedding-planners/noemi-wedding/reviews",
  "/italy/veneto/wedding-planners/suellen-fernandes-weddings/reviews",
  "/italy/veneto/wedding-venues/castello-bevilacqua/reviews",
  "/italy/venice/hair-makeup/lisa-semenzato/reviews",
  "/italy/venice/photographers/alfonso-lorenzetto/reviews",
  "/italy/venice/photographers/barbara-zanon-photography/reviews",
  "/italy/venice/photographers/mauro-pozzer-photography/reviews",
  "/malaysia/pahang/wedding-venues/the-chateau-spa/reviews",
  "/malaysia/terengganu/wedding-venues/the-taaras-beach-spa-resort/reviews",
  "/morocco/draa-valley/wedding-venues/kasbah-des-caids/reviews",
  "/poland/west-pomerania/wedding-venues/manowce-palace/reviews",
  "/portugal/alentejo/wedding-venues/craveiral-farmhouse/reviews",
  "/portugal/lisbon/photographers/dimas-frolov-photography/reviews",
  "/scotland/aberdeenshire/wedding-venues/cluny-castle/reviews",
  "/scotland/aberdeenshire/wedding-venues/cortes-house/reviews",
  "/scotland/east-lothian/wedding-venues/greywalls-hotel-chez-roux/reviews",
  "/scotland/fife/wedding-venues/old-course-hotel/reviews",
  "/scotland/highlands/wedding-venues/inverlochy-castle-hotel/reviews",
  "/slovenia/gorenjska/wedding-venues/bled-rose-hotel/reviews",
  "/spain/balearic-islands/wedding-planners/the-mallorca-wedding-company/reviews",
  "/spain/galicia/photographers/volvoreta-photography/reviews",
  "/spain/ibiza/photographers/kaleidos-wedding/reviews",
  "/spain/ibiza/wedding-venues/can-lluc-hotel/reviews",
  "/spain/ibiza/wedding-venues/kazamor-ibiza/reviews",
  "/spain/mallorca/wedding-venues/castell-son-claret/reviews",
  "/spain/menorca/wedding-venues/amagatay-menorca/reviews",
  "/spain/tenerife/wedding-venues/the-ritz-carlton-abama/reviews",
  "/sri-lanka/colombo/videographers/lights-and-magic/reviews",
  "/switzerland/bernese-oberland/videographers/story-of-your-day/reviews",
  "/switzerland/obwalden/wedding-venues/frutt-mountain-resort/reviews",
  "/switzerland/vaud/wedding-planners/daria-events/reviews",
  "/thailand/phuket/wedding-venues/vanderbilt-estate/reviews",
  "/turkey/bodrum/wedding-venues/villa-macakizi-bodrum/reviews",
  "/uae/dubai/wedding-venues/burj-al-arab-jumeirah/reviews",
  "/uae/dubai/wedding-venues/jumeirah-zabeel-saray/reviews",
  "/united-states/california/photographers/duke-photography/reviews",
  "/united-states/california/photographers/samuel-lippke-studios/reviews",
  "/united-states/washington/photographers/emett-joseph-photography/reviews",
  "/usa/rhode-island/wedding-venues/rosecliff/reviews",
  "/wales/cardiff/hair-makeup/loxus-hair-and-makeup/reviews"
];
